app.config([
  '$translateProvider',
  function ($translateProvider) {
    $translateProvider.translations("vi", {
        "AC": "Ascension Island",
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AX": "Åland Islands",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BQ": "Caribbean Netherlands",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BV": "Bouvet Island",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos [Keeling] Islands",
        "CD": "Congo [DRC]",
        "CF": "Central African Republic",
        "CG": "Congo [Republic]",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CP": "Clipperton Island",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curaçao",
        "CX": "Christmas Island",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DG": "Diego Garcia",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EA": "Ceuta and Melilla",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "EU": "European Union",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands [Islas Malvinas]",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GF": "French Guiana",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GP": "Guadeloupe",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GS": "South Georgia and the South Sandwich Islands",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HM": "Heard Island and McDonald Islands",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "IC": "Canary Islands",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar [Burma]",
        "MN": "Mongolia",
        "MO": "Macau",
        "MP": "Northern Mariana Islands",
        "MQ": "Martinique",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NF": "Norfolk Island",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn Islands",
        "PR": "Puerto Rico",
        "PS": "Palestinian Territories",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "QO": "Outlying Oceania",
        "RE": "Réunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "São Tomé and Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TA": "Tristan da Cunha",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TF": "French Southern Territories",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor-Leste",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "UM": "U.S. Outlying Islands",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Vatican City",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "ZZ": "Unknown Region",
        "action.add_photo": "Thêm ảnh",
        "action.load_earlier": "Tải trước đó",
        "action.load_more": "Tải thêm",
        "action.send": "Gửi",
        "address.fields.address": "Địa chỉ",
        "address.fields.address.city": "Thành phố",
        "address.fields.address.country": "Quốc gia",
        "address.fields.address.postcode": "Mã bưu chính (nếu có)",
        "address.fields.address.recipient_name": "Tên Người nhận",
        "address.fields.address.remarks": "Ghi chú",
        "address.fields.address.state": "Quận/Bang/Tỉnh",
        "address.fields.city": "Thành phố",
        "address.fields.country": "Quốc gia",
        "address.fields.postcode": "Mã bưu chính",
        "address.fields.recipient_name": "Tên Người nhận",
        "attachment.upload.description": "Tệp phải nhỏ hơn 2MB \nLoại tệp cho phép sử dụng: pdf, doc, docx, xls, xlsx, csv, jpg, jpeg, png, gif",
        "back": "Back",
        "back_in_stock.added": "Đã bật thông báo khi có hàng mới về",
        "back_in_stock.avaiable": "Gửi thông báo khi có hàng",
        "back_in_stock.subscibe.success.message": "Khi sản phẩm có hàng mới về, chúng tôi sẽ gửi thông báo cho bạn.",
        "back_member_center": "Back to Member Center",
        "birthday_picker.date.placeholder": "Date",
        "birthday_picker.month.placeholder": "Month",
        "birthday_picker.year.placeholder": "Year",
        "cart": "Giỏ hàng",
        "cart.affiliate_code.apply_success": "Affiliate Applied",
        "cart.checkout": "Thanh toán",
        "cart.clean": "Thanh toán ngay bây giờ!",
        "cart.copy.info.affiliate_code": "Mã giới thiệu ({{code}}), ",
        "cart.copy.info.copied": "Đã sao chép địa chỉ trang web:",
        "cart.copy.info.product_count": "{{count}} sản phẩm",
        "cart.coupon_code.apply_success": "Coupon Applied",
        "cart.empty": "Giỏ hàng của bạn đang trống.",
        "cart.empty.continue": "Tiếp tục mua sắm ngay!",
        "cart.empty.description": "Thêm sản phẩm vào giỏ hàng để tiếp tục.",
        "cart.item.remove": "Xóa",
        "cart.items.remove": "Xóa",
        "cart.lock_cart_sc_product.description": "Sản phẩm này đã được đặt qua Live stream/ Bài đăng bán hàng, không thể thay đổi số lượng sản phẩm",
        "cart.lock_cart_sc_product.remove_hint": "Sản phẩm này đã được đặt qua Live stream/ Bài đăng bán hàng, không thể xóa sản phẩm",
        "cart.over_limit": "Giỏ hàng vượt quá số lượng <span class=\"limit-number\">{{limit_number}}</span> mặt hàng tối đa, vui lòng kiểm tra trước khi thêm mặt hàng mới. Bạn cũng có thể đăng nhập để thêm các mục này vào danh sách yêu thích của mình!",
        "cart.over_limit.login": "Giỏ hàng vượt quá số lượng <span class=\"limit-number\">{{limit_number}}</span> mặt hàng tối đa, vui lòng kiểm tra trước khi thêm mặt hàng mới. Bạn cũng có thể thêm mặt hàng này vào danh sách yêu thích của mình!",
        "cart.promotion.bundle_group.has_items_selected": "Nhóm A <b style=\"color: #f05c53\">{{red_quantity}}</b> sản phẩm đã được chọn{{red_reminder}}; Nhóm B <b style=\"color: #1ba462\">{{green_quantity}}</b> sản phẩm đã được chọn{{green_reminder}}{{applied_reminder}}",
        "cart.promotion.bundle_group.has_items_selected.mobile": "Nhóm A <b style=\"color: #f05c53\">{{red_quantity}}</b> sản phẩm; Nhóm B <b style=\"color: #1ba462\">{{green_quantity}}</b> sản phẩm",
        "cart.promotion.checkout": "Checkout",
        "cart.promotion.has_items_selected": "<b>{{quantity}}</b> sản phẩm đã được chọn",
        "cart.promotion_reminder.amount": "Mua thêm {{gap}} ",
        "cart.promotion_reminder.applied.discount": "Tận hưởng ưu đãi, ",
        "cart.promotion_reminder.applied.discount_prefix": ". ",
        "cart.promotion_reminder.applied.free_shipping": "Tận hưởng miễn phí ship",
        "cart.promotion_reminder.applied.gift": "Tận hưởng Quà tặng miễn phí",
        "cart.promotion_reminder.applied.reward_campaign": "Tận hưởng ưu đãi, ",
        "cart.promotion_reminder.applied_highest.discount": "Tận hưởng ưu đãi!",
        "cart.promotion_reminder.applied_highest.free_shipping": "Tận hưởng miễn phí ship!",
        "cart.promotion_reminder.applied_highest.gift": "Tận hưởng Quà tặng miễn phí!",
        "cart.promotion_reminder.applied_highest.reward_campaign": "Tận hưởng ưu đãi!",
        "cart.promotion_reminder.discount_target.discount": "để nhận được ưu đãi!",
        "cart.promotion_reminder.discount_target.free_shipping": "để được miễn phí ship!",
        "cart.promotion_reminder.discount_target.gift": "để được quà tặng miễn phí!",
        "cart.promotion_reminder.discount_target.reward_campaign": "để nhận được ưu đãi!",
        "cart.promotion_reminder.group_gap": " (còn {{gap}} sản phẩm nữa)",
        "cart.promotion_reminder.group_green": "<span class=\"bundle-group-label bundle-group-green\">Nhóm B</span> còn {{gap}} sản phẩm nữa",
        "cart.promotion_reminder.group_red": "<span class=\"bundle-group-label bundle-group-red\">Nhóm A</span> còn {{gap}} sản phẩm nữa",
        "cart.promotion_reminder.item": "Mua thêm {{gap}} sản phẩm ",
        "cart.promotion_reminder.multiple_step": "để tiết kiệm hơn!",
        "cart.promotion_reminder.multiple_step.reward_campaign": "to save more!",
        "cart.promotion_reminder.separator": ". ",
        "cart.promotion_reminder.stackable": "Mua nhiều hơn, tiết kiệm hơn!",
        "cart.redeem_gift.has_items_selected": "<span>{{total_point}}</span> points used, <span>{{rest_point}}</span> points left",
        "cart.redeem_gift.has_items_selected.insufficient_point": "Exceed <span>{{rest_point}}</span> points, please remove some gifts.",
        "cart.related_products.title": "You might also like...",
        "cart.share.btn.tooltip": "Sao chép các sản phẩm trong giỏ hàng và chia sẻ cho bạn bè",
        "cart.sl_cashback.gain_toast": "Cashback eligible",
        "cart.sl_cashback.lost_toast": "Cashback unavailable for this payment method",
        "cart.title": "Giỏ hàng",
        "checkout.auto_fill.popup.cancel": "Hủy bỏ",
        "checkout.auto_fill.popup.continue": "Tiếp tục",
        "checkout.auto_fill.popup.error": "Vui lòng nhập đúng định dạng",
        "checkout.auto_fill.popup.title": "Nhập điện thoại của bạn để thanh toán nhanh chóng",
        "checkout.auto_fill.toast.error": "Nếu không có hồ sơ về đơn hàng cuối cùng được phát hiện, dữ liệu thanh toán nhanh sẽ không được đưa vào",
        "checkout.card_info_error": "Please verify the information and try again.",
        "checkout.card_type_not_support_error": "The card type is not supported at this moment",
        "checkout.cart_over_limit_error": "Tối đa 100 sản phẩm, vui lòng điều chỉnh lại số lượng mua hàng.",
        "checkout.delivery_option.out_of_stock": "Một số sản phẩm đã hết hàng, không thể chọn cửa hàng này, vui lòng thử cửa hàng khác.",
        "checkout.delivery_option.title": "Địa chỉ Giao hàng",
        "checkout.discount.applied_coupons": "Phiếu giảm giá đã sử dụng",
        "checkout.discount.applied_promotions": "Khuyến mãi đã sử dụng",
        "checkout.fields.add_new": "Thêm mới...",
        "checkout.fields.delivery_method": "Phương thức Giao hàng",
        "checkout.fields.email": "Email của Khách hàng",
        "checkout.fields.email.hint": "Vui lòng điền địa chỉ email chính xác vì xác nhận đơn hàng sẽ được gửi tới email của bạn.",
        "checkout.fields.email.placeholder": "Địa chỉ Email",
        "checkout.fields.out_of_stock": "Rất tiếc, không còn đủ hàng, vui lòng xóa sản phẩm khỏi giỏ hàng và thanh toán lại.",
        "checkout.fields.phone": "Số điện thoại liên hệ",
        "checkout.fields.phone.hint": "Xin hãy điền số điện thoại di động của bạn để nhận cập nhật tình trạng giao hàng qua SMS",
        "checkout.fields.phone.invali": "Số điện thoại không hợp lệ",
        "checkout.fields.phone.invalid": "Invalid phone number",
        "checkout.fields.phone.placeholder": "Nhập số điện thoại liên hệ của bạn",
        "checkout.fields.remarks": "Ghi chú cho Cửa hàng",
        "checkout.fields.remarks.placeholder": "Để lại ghi chú về đơn hàng cho Cửa hàng",
        "checkout.fields.select": "Chọn một...",
        "checkout.instalment_amount": "khoảng {{amount}} x {{period}} lần thanh toán",
        "checkout.instructions": "Chi tiết đơn hàng",
        "checkout.labels.promotion.coupon": "Phiếu giảm giá",
        "checkout.labels.promotion.free_shipping": "Miễn phí vận chuyển",
        "checkout.labels.promotion.membership": "Khuyến mãi dành cho thành viên",
        "checkout.labels.promotion.promotion": "Khuyến mãi",
        "checkout.payment_condition.continue_shopping": "Tiếp tục mua sắm",
        "checkout.payment_condition.description": "Để có thể tiếp tục thanh toán, vui lòng quay lại trang giỏ hàng để chọn phương thức thanh toán khác hoặc tiếp tục mua sắm",
        "checkout.payment_condition.hint": "Đơn hàng này phải đáp ứng số tiền đặt hàng tối thiểu để có thể tiếp tục thanh toán",
        "checkout.payment_condition.title": "Vẫn thiếu {{difference}} để đáp ứng điều kiện thanh toán!",
        "checkout.payment_failed": "Giao dịch không thành công, vui lòng thử lại.",
        "checkout.payment_failed.atome.minamount": "Đơn hàng không đáp ứng số tiền thanh toán tối thiểu của phương thức thanh toán, vui lòng chỉnh sửa nội dung giỏ hàng hoặc chuyển sang phương thức thanh toán khác.",
        "checkout.payment_failed.check_credit_card_info": "Please make sure you provided the correct information of your credit card, or you may contact with merchants or card issuing banks.",
        "checkout.payment_method.title": "Thanh toán",
        "checkout.payments.apple_pay.not_supported": "Thiết bị này không hỗ trợ Apple Pay, xin hãy kiểm tra dưới đây<ul><li>Vui lòng ĐĂNG NHẬP vào trình duyệt bằng Tài khoản Apple của bạn</li><li>Xin hãy THÊM  phương thức thanh toán vào Tài khoản Apple Pay của bạn</li><li>Xin hãy NÂNG CẤP thiết bị và trình duyệt lên phiên bản mới nhất</li></ul>",
        "checkout.payments.exist.order.tip": "You have already placed order <a href=\"{{ duplicateOrderLink }}\">{ {{order}} }</a>. If you wish to complete the checkout, please click “Place Order”.",
        "checkout.payments.google_pay.not_supported": "Thiết bị này không hỗ trợ Google Pay, xin hãy kiểm tra dưới đây<ul><li>Vui lòng ĐĂNG NHẬP vào trình duyệt bằng Tài khoản Google của bạn</li><li>Xin hãy THÊM  phương thức thanh toán vào Tài khoản Google Pay của bạn</li><li>Xin hãy NÂNG CẤP thiết bị và trình duyệt lên phiên bản mới nhất</li></ul>",
        "checkout.payments_transaction_error": "There is some issue with your order. Please check the payment information again or contact your card’s issuing bank directly.",
        "checkout.promotion.tags.coupon": "Phiếu giảm giá",
        "checkout.promotion.tags.free_shipping": "Miễn phí Vận chuyển",
        "checkout.promotion.tags.membership": "Ưu đãi cho Thành viên",
        "checkout.promotion.tags.promotion": "Khuyến mãi",
        "checkout.promotion.tags.subscription_promotion": "Khuyến mãi sản phẩm đăng ký định kỳ",
        "checkout.recipient_name_invalid": "Invalid recipient name. Please enter up to 10 characters without spaces or special characters.",
        "checkout.recipient_phone_invalid": "Recipient Phone Number is incorrect, please check again.",
        "checkout.station_space_confirm_error": "Failed to select pickup store, please try again or contact us",
        "checkout.store_unavailable": "Store unavailable. Please choose another.",
        "checkout.timeout": "There is an issue with your payment. If you place an order again, there may be a repeat order. Please contact us to check on the payment status.",
        "checkout_object.detail.close": "Close",
        "checkout_object.detail.title": "Checkout Amount Detail",
        "close": "Đóng",
        "cookie_consent_popup.buttons.accept": "Accept",
        "cookie_consent_popup.buttons.save_preferences": "Save Preferences",
        "cookie_consent_popup.buttons.settings": "Settings",
        "cookie_consent_popup.claim.description": "Hi, this website uses essential cookie to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only upon approval.",
        "cookie_consent_popup.claim.heading": "We use cookies",
        "cookie_consent_popup.claim.read_more": "Read more",
        "cookie_consent_popup.cookie_descriptions.functionality": "These cookies allow a website to remember choices you have made in the past, like what language you prefer, or what currency you prefer.",
        "cookie_consent_popup.cookie_descriptions.marketing": "These cookies collect your online activity to help advertisers deliver more relevant advertising or to limit how many times you see an ad. These cookies can share that information with other organizations or advertisers. These are persistent cookies and almost always of third-party provenance.",
        "cookie_consent_popup.cookie_descriptions.necessary": "These cookies are required to enable core website functionality and are automatically enabled when you use the site. These include cookies that help to make the shopping cart and checkout process possible, as well as assisting in security issues and conforming to regulations.",
        "cookie_consent_popup.cookie_descriptions.statistical": "These cookies collect information on how you use the website, for instance which pages you visit most often or if you got any error message. The information collected by these cookies is aggregated and therefore anonymous. We use them for advertising measurement and to improve how the website works.",
        "cookie_consent_popup.cookie_names.functionality": "Functionality cookies",
        "cookie_consent_popup.cookie_names.marketing": "Marketing cookies",
        "cookie_consent_popup.cookie_names.necessary": "Strictly necessary cookies",
        "cookie_consent_popup.cookie_names.statistical": "Statistical cookies",
        "coupon.already_taken": "Bạn đã lấy phiếu giảm giá này",
        "coupon.back_to_cart_button": "Checkout",
        "coupon.close": "Đóng",
        "coupon.comingSoon": "Sắp ra mắt",
        "coupon.confirm": "Xác nhận",
        "coupon.congratulation": "Coupon claimed",
        "coupon.expired": "Hết hạn",
        "coupon.first_purchase_only": "Đơn hàng đầu tiên",
        "coupon.first_purchase_only.with_platform": "1st Purchase Only in {{platform}}",
        "coupon.first_shoppers": "Chỉ {{number}} người mua đầu tiên",
        "coupon.invalid": "Vô hiệu lực",
        "coupon.is_expired": "Coupon expired",
        "coupon.login": "Đăng nhập",
        "coupon.login_or_register": "Vui lòng nhấp vào nút bên dưới để đăng nhập hoặc đăng ký",
        "coupon.login_to_receive": "Đăng nhập để nhận phiếu giảm giá",
        "coupon.no_available_coupon": "No Available Coupon",
        "coupon.no_comingSoon_coupon": "No Coming Soon Coupon",
        "coupon.no_invalid_coupon": "Không có mã giảm giá vô hiệu lực",
        "coupon.no_valid_coupon": "Không có mã giảm giá có hiệu lực",
        "coupon.not_eligible": "Không đủ điều kiện sử dụng phiếu giảm giá",
        "coupon.one_time": "Một lần",
        "coupon.online_and_selected_retail_store_only": "",
        "coupon.online_store_only": "",
        "coupon.only_tag": "được ưu đãi riêng",
        "coupon.reach_limit": "Đạt giới hạn",
        "coupon.retail_store_only": "",
        "coupon.select_coupon": "Chọn mã giảm giá",
        "coupon.selected_retail_store_list": "Danh sách cửa hàng bán lẻ được chọn",
        "coupon.selected_retail_store_only": "",
        "coupon.start_at": "Begins on <span class=\"coupon-period-time\"><div class=\"coupon-period-tip\">Display in your time zone<br/>(GMT{{timeZone}})</div> {{time}} </span>",
        "coupon.success": "Lấy thành công",
        "coupon.title": "Mã giảm giá",
        "coupon.unfit_first_purchase": "Coupon is only for the first purchase order",
        "coupon.usage_limit": "All coupons have been claimed",
        "coupon.used": "Used",
        "coupon.valid": "Có hiệu lực",
        "coupon.valid_until": "Kết thúc vào ngày <span class=\"coupon-period-time\"><div class=\"coupon-period-tip\">Hiển thị theo múi giờ của bạn <br/>(GMT{{timeZone}})</div> {{time}} </span>",
        "coupon.view": "Xem phiếu giảm giá",
        "coupon_center": "Coupon Center",
        "coupon_center.empty": "没有可领取的优惠券",
        "coupon_input.claim": "Claim",
        "coupon_input.claim_failed": "Failed to claim",
        "coupon_input.claim_succeed": "Congratulations on getting {{ couponName }} coupon.",
        "coupon_input.claim_succeed.redirect": "Congratulations on getting {{ couponName }} coupon. View it in the member center!",
        "coupon_input.placeholder": "Enter coupon code",
        "coupon_v2.claim": "Claim now",
        "coupon_v2.claim.success": "Congratulations on getting {{ name }} coupon",
        "coupon_v2.claimed": "Claimed",
        "coupon_v2.copy_code": "Copy Code",
        "coupon_v2.copy_code.success": "Code Copied",
        "coupon_v2.discount_type.discount": "Discount",
        "coupon_v2.discount_type.free_shipping": "Free Shipping",
        "coupon_v2.discount_type.gift": "Free Gift",
        "coupon_v2.first_purchase_only": "For 1st purchase only",
        "coupon_v2.first_purchase_with_platform": "For 1st {{platform}} purchase only",
        "coupon_v2.login_to_claim": "Log in to claim",
        "coupon_v2.no_quota": "All claimed",
        "coupon_v2.period.end_at": "End at {{ date }}",
        "coupon_v2.period.start_at": "Start at {{ date }}",
        "coupon_v2.use": "Use",
        "delivery.sfexpress.district": "SF Express Quận",
        "delivery.sfexpress.ef_locker": "EF Locker",
        "delivery.sfexpress.locker_location": "Vị trí Locker",
        "delivery.sfexpress.store": "SF Express Địa điểm",
        "delivery_address.district.hk": "Quận",
        "delivery_address.district.th": "Quận/ Huyện",
        "delivery_address.district.tw": "Quận",
        "delivery_address.district.vn": "District",
        "delivery_address.province.th": "Tỉnh/ Thành phố",
        "delivery_address.province.vn": "Province",
        "delivery_address.region.hk": "Vùng",
        "delivery_address.region.tw": "Bang/Thành phố",
        "delivery_address.store": "Cửa hàng {{ station_name }}",
        "delivery_address.street": "Đường / Phố",
        "delivery_address.ward.th": "Phường/ Xã",
        "delivery_address.ward.vn": "Ward",
        "delivery_fee.pay.on.delivery": "You will be charged for shipping when the goods arrive.",
        "delivery_options.fields.delivery_type": "Loại Giao hàng",
        "delivery_options.fields.delivery_types.custom": "Tùy chỉnh",
        "delivery_options.fields.delivery_types.email": "Email",
        "delivery_options.fields.delivery_types.international": "Quốc tế",
        "delivery_options.fields.delivery_types.local": "Trong nước",
        "delivery_options.fields.delivery_types.pickup": "Đến lấy",
        "delivery_options.fields.delivery_types.tw_simple_711": "7-11 Đến lấy (chỉ ở TW)",
        "delivery_options.fields.delivery_types.tw_simple_familymart": "Family Mart Đến lấy (chỉ ở TW)",
        "delivery_options.fields.select_date": "Ngày đến",
        "dropdown.hint": "Xin hãy lựa chọn",
        "dynamic.delivery.fee.calculate.desc": "Shipping rate for the first 1 kg + (total weight-1 kg) * shipping rate for additional weight",
        "dynamic.delivery.fee.calculate.hint": "If the total weight is less than 1 kg, it will be calculated as 1 kg",
        "dynamic.delivery.fee.calculate.info": "Phí giao hàng: {{totalDeliveryFee}}",
        "dynamic.delivery.fee.calculate.title": "Shipping rate calculation method",
        "dynamic.delivery.fee.no.state.info": "The shipping rate will be displayed after confirming the shipping address",
        "dynamic.delivery.fee.no.state.notice": "Phí giao hàng sẽ được hiển thị trên trang thanh toán sau khi địa chỉ giao hàng được cập nhật.",
        "dynamic.delivery.fee.updated.notice": "Shipping rate has been updated",
        "error.401.description": "Bạn không được ủy quyền để truy cập trang này",
        "error.401.title": "Chúng tôi rất tiếc",
        "error.403.description": "Bạn không được ủy quyền để truy cập trang này",
        "error.403.not_signed_in.anchor": "đăng nhập",
        "error.403.not_signed_in.message": ", có thể do bạn chưa ",
        "error.403.title": "Chúng tôi rất tiếc",
        "error.404.description": "Trang này không tồn tại",
        "error.404.title": "Chúng tôi rất tiếc",
        "error.continue": "Tiếp tục mua sắm ngay!",
        "ezship.error.account_not_exist": "Tài khoản ezShip không tồn tại. Xin hãy liên hệ với người bán",
        "ezship.error.invalid_amount": "Số tiền không hợp lệ. Số tiền tối đa được phép khi sử dụng ezShip là 6000 TWD mỗi đơn hàng.",
        "ezship.error.invalid_email": "Email không hợp lệ",
        "ezship.error.invalid_input": "Một hoặc nhiều trường không hợp lệ hoặc bị thiếu",
        "ezship.error.invalid_mobile": "Số điện thoại không hợp lệ",
        "ezship.error.invalid_name": "Tên người nhận không hợp lệ",
        "ezship.error.invalid_store": "Cửa hàng Đến lấy Không hợp lệ",
        "ezship.error.no_easybag": "Tài khoản ezShip không có Easybag hoặc Minibag khả dụng",
        "ezship.error.no_permission": "Tài khoản ezShip không đủ cấp phép",
        "ezship.error.system_error": "Lỗi hệ thống ezShip. Vui lòng chọn phương thức giao hàng khác hoặc thử lại sau.",
        "facebook_banner.description": "Bạn đang truy cập trang web trên trình duyệt trong ứng dụng Facebook, vui lòng sử dụng trình duyệt khác nếu bạn gặp sự cố khi tải lên hình ảnh. <span>Sao chép đường dẫn</span>",
        "facebook_messenger_checkbox.subscribe": "Send to Messenger",
        "facebook_messenger_checkbox.subscribed": "Đã được gửi tới {{topic}} qua <img src=\"https://{{image_host}}/assets/misc/fb_messenger_36x.png\" class=\"fb-app-icon\">Messenger",
        "facebook_messenger_checkbox.topics.MARKETING": "cập nhật và khuyến mãi của cửa hàng",
        "facebook_messenger_checkbox.topics.ORDER_STATUS_UPDATE,DELIVERY_STATUS_UPDATE": "thông báo cập nhật đơn hàng",
        "facebook_messenger_checkbox.turn_off": "Tắt",
        "facebook_messenger_checkbox.v2.subscribe": "Send to Messenger",
        "facebook_messenger_checkbox.v2.subscribed": "Send via Facebook",
        "fb_in_app_browser_popup.copy_link": "Copy Link.",
        "fb_in_app_browser_popup.desc": "You’re visiting the website via built-in browser of Facebook app, please use another browser in case of any failure during checkout. ",
        "form.action.delete": "Xóa",
        "form.response.load.more.error": "Unable to load the data, please try again.",
        "form.validation.birthday.invalid": "Birthday is invalid",
        "form.validation.birthday.invalid.minimum_age_limit": "Ngày sinh không hợp lệ, phải trên {{minimumAgeLimit}} tuổi",
        "form.validation.birthday.required": "Birthday is required",
        "form.validation.calling_code": "Mã quốc gia là bắt buộc",
        "form.validation.card.bin.error": "Current payment method is not applicable to your credit card. Please contact shop owner for details.",
        "form.validation.card.bin.error.unknow_scheme": "We cannot identify your credit card type. Please email shop owner for details.",
        "form.validation.confirmation": "Mật khẩu không khớp.",
        "form.validation.delivery_option.country": "Loại giao hàng bạn đã chọn không được cung cấp ở quốc gia này, vui lòng thay đổi địa chỉ giao hàng hoặc chọn phương thức giao hàng khác.",
        "form.validation.delivery_option.cross_border.MY": "The delivery type you have chosen is not available for {{ area == \"west\" ? \"West\" : \"East\" }} Malaysia, please change your delivery address or choose another delivery method",
        "form.validation.delivery_option.local": "Loại giao hàng bạn đã chọn không được cung cấp cho các đảo ở Đài Loan, vui lòng thay đổi địa chỉ giao hàng tới các đảo xa hoặc chọn phương thức giao hàng khác.",
        "form.validation.delivery_option.outlying": "Loại giao hàng bạn đã chọn không được cung cấp cho các đảo xa ở Đài Loan, vui lòng thay đổi địa chỉ giao hàng hoặc chọn phương thức giao hàng khác.",
        "form.validation.delivery_option.region": "Loại giao hàng bạn đã chọn không được cung cấp ở vùng này, vui lòng thay đổi địa chỉ giao hàng hoặc chọn phương thức giao hàng khác.",
        "form.validation.email": "{{field_name}} không hợp lệ",
        "form.validation.email.duplicate": "Email này đã được sử dụng, vui lòng điền một email khác.",
        "form.validation.email.hint": "Vui lòng nhập một địa chỉ email hợp lệ.",
        "form.validation.id_no": "Vui lòng điền số CMND thực của người nhận để khai báo nhập khẩu thuận lợi",
        "form.validation.invalid": "{{field_name}} không hợp lệ",
        "form.validation.maxlength": "{{field_name}} quá dài",
        "form.validation.maxlength.with.number": "{{field_name}} is up to {{max_length}} characters",
        "form.validation.minlength": "{{field_name}} quá ngắn",
        "form.validation.mobile.error": "{{field_name}} is incorrect, please enter mobile phone",
        "form.validation.passport": "Vui lòng điền số hộ chiếu thực của người nhận để khai báo nhập khẩu thuận lợi",
        "form.validation.pattern": "{{field_name}} không hợp lệ",
        "form.validation.pattern.711_cross_border.delivery_address": "Vui lòng viết bằng tiếng Anh cho các dịch vụ vận chuyển xuyên biên giới",
        "form.validation.pattern.customer_name.user_name_invalid": "Invalid name: The input contains unsupported symbols.",
        "form.validation.pattern.recipient-name": "Không cho phép dùng dấu cách và biểu tượng, hoặc quá {{limit_length}} ký tự.",
        "form.validation.pattern.recipient-phone.TW": "{{field_name}} phải nhập 10 chữ số",
        "form.validation.pattern.recipient-phone.above_size": "Recipient contact number must input more than {{ max_count }} digits numbers",
        "form.validation.pattern.recipient-phone.beginning_stint": "Recipient Contact Number must start with {{ stint_charts.split(\",\").join(\" or \") }}",
        "form.validation.pattern.recipient-phone.fix_size": "Recipient Contact Number must input {{ max_count }} digits numbers",
        "form.validation.phone.error": "{{field_name}} không chính xác, vui lòng kiểm tra lại",
        "form.validation.phone.required": "{{field_name}} là bắt buộc",
        "form.validation.policy": "Bạn phải đồng ý với các điều khoản và điều kiện để tiếp tục.",
        "form.validation.required": "{{field_name}} là bắt buộc",
        "form.validation.unique": "{{field_name}} đã có người dùng. Xin hãy chọn lại.",
        "gift.exceed.limit": "Exceed gift purchase limit, please adjust your quantity.",
        "gift.items_needed.hint": "<span class=\"highlight-label\">{{ quantity }}</span> more product(s) to complete the selection",
        "gift.quantity_label.unqualified": "{{ quantity }} item(s) needed",
        "gift.sold_out": "The gift you selected is out of stock.",
        "gift.variation.confirm": "Confirm",
        "go_coupon_center": "Go to Coupon Center",
        "hk_sfplus.address": "{{region}}, {{district}}, {{area}}",
        "hk_sfplus.area": "Khu vực",
        "hk_sfplus.district": "Quận",
        "hk_sfplus.region": "Vùng",
        "imagepicker.title": "Tải ảnh lên",
        "in_app_browser_popup.desc": "Để đăng nhập và thanh toán để có trải nghiệm mua sắm tốt hơn, chúng tôi khuyên bạn nên mở trình duyệt mặc định.",
        "languages.en": "English",
        "languages.id": "bahasa Indonesia",
        "languages.jp": "日本語",
        "languages.vi": "Việt nam",
        "languages.zh-hant": "中文",
        "line_messenger_checkbox.button.unsubscribe": "Turn off",
        "line_messenger_checkbox.order_notification.subscribed": "Sent this order update notifications via",
        "line_messenger_checkbox.subscribe": "Send to LINE",
        "line_messenger_checkbox.subscribed": "Sent via LINE",
        "lock_inventory.locked_quantity_unit": "sản phẩm",
        "lock_inventory.tooltip": "Giữ hàng đến {{expired_time}}\n(Phát trực tiếp lúc {{start_time}}:{{event_name}})\nHiển thị theo múi giờ địa phương của bạn（GMT{{timezone}}）",
        "media.validation.error": "Lỗi tải ảnh lên",
        "media.validation.error.file_attachment_size": "Hãy tải lên một tập tin nhỏ hơn 2MB.",
        "media.validation.error.file_size": "Hãy tải lên hình ảnh nhỏ hơn 5MB.",
        "media.validation.file_limit.one": "You may only upload up to 1 files",
        "media.validation.type": "chỉ cho phép các định dạng jpeg và png",
        "member.center.load.more": "Nhiều hơn",
        "member.center.load.more.error": "Không thể tải dữ liệu, vui lòng thử lại.",
        "member_point": "points",
        "member_points.display.expire_point": "points will expire on",
        "member_points.display.successive_expire_point": "points will expire in succession after",
        "member_points.earn_from_order_description": "",
        "member_points.equal_cash": "Tương đương với {{money}}",
        "member_points.fields.auto_reward": "Points rewarded from order",
        "member_points.fields.auto_reward_seconds": "",
        "member_points.fields.date": "Date",
        "member_points.fields.expire": "",
        "member_points.fields.expired": "Điểm đã hết hạn",
        "member_points.fields.expiry_date": "Expiry Date",
        "member_points.fields.member_info_reward": "Phần thưởng điểm thành viên hoàn thành hồ sơ thành viên",
        "member_points.fields.member_point_expired": "Point Expired",
        "member_points.fields.product_review_reward": "Đã hoàn tất đánh giá cho đơn hàng <a href=\"{{link}}\">{{ orderNumber }}</a>",
        "member_points.fields.remarks": "Point Change Reason",
        "member_points.fields.revert_member_point": "Points reverted from cancelled order",
        "member_points.fields.revert_member_point.order_edit": "Điểm thưởng được hoàn trả từ đơn hàng đã chỉnh sửa",
        "member_points.fields.revert_member_point.order_split": "Points reverted from split order",
        "member_points.fields.revert_member_point.return": "Points reverted from returned order",
        "member_points.fields.revert_member_point.return_order_revert": "Reverted points; from return",
        "member_points.fields.successive_expire": "",
        "member_points.fields.value": "Point Movement",
        "member_points.no_data": "No point records",
        "member_points.point_balance": "Point Balance",
        "member_points.point_history": "Point History",
        "member_points.redeem_cash_and_earn_from_order_description": "",
        "member_points.redeem_cash_description": "",
        "member_points.rule": "Points Rules",
        "member_points.title": "Điểm thành viên",
        "member_points.unit": "Point",
        "member_referral.code.copy_and_share": "Chia sẻ liên kết với bạn bè của bạn, cả hai bạn đều sẽ nhận được điểm tín dụng của cửa hàng.",
        "member_referral.code.remarks": "Quy tắc chiến dịch",
        "member_referral.copy.link": "Sao chép liên kết",
        "member_referral.copy.link.success": "Liên kết được sao chép",
        "member_referral.discount": "Chiến dịch giới thiệu thành viên",
        "member_referral.generate.code": "Tạo liên kết giới thiệu",
        "member_referral.generate.code.success": "Liên kết giới thiệu được tạo",
        "member_referral.rules": "Quy tắc chiến dịch",
        "member_referral.welcome_credit.popup.content": "Bạn đã kiếm được {{reward_value}} điểm tín dụng. Bạn có thể giới thiệu bạn bè của mình để kiếm thêm điểm tín dụng.",
        "member_referral.welcome_credit.popup.continue": "Mua ngay",
        "member_referral.welcome_credit.popup.title": "Xin chúc mừng, bạn đã kiếm được {{reward_value}} điểm tín dụng",
        "membership.profile.check.code.error": "Mã kiểm tra không đúng! Xin hãy nhập lại hoặc gửi lại tin nhắn sms mã kiểm tra",
        "membership.profile.email_subscription.error": "To subscribe to Email, please enter an email address and try again.",
        "membership.profile.mobile.number.verified": "Số điện thoại di động đã được xác thực và sẽ thay thế số điện thoại bạn đã lưu trước đó.",
        "membership.profile.sms_subscription.error": "To subscribe to SMS, please enter an mobile phone and try again.",
        "membership.profile.subscriptions.marketing.news": "Cập nhật và khuyến mãi của cửa hàng",
        "membership.profile.subscriptions.messages.new": "Tin nhắn mới từ người bán",
        "membership.profile.subscriptions.none": "Không có",
        "membership.profile.subscriptions.orders.comments.new": "Ý kiến mới từ người bán với đơn hàng của tôi",
        "membership.profile.subscriptions.orders.update.status": "Cập nhật đơn hàng của tôi",
        "membership.profile.verification_hint": "Nếu bạn thay đổi địa chỉ email thì cần phải xác minh sau khi lưu. Email sẽ được cập nhật thành {{unconfirmed_email}} sau khi xác minh xong.",
        "messages.form.send": "Gửi",
        "model.credit_card.choose_card": "Fast checkout with your saved card",
        "model.credit_card.subtitle": "Vui lòng nhập thẻ tín dụng bên dưới để cập nhật",
        "model.credit_card.title": "Thông tin thẻ tín dụng của bạn",
        "model.credit_card.use_new_card": "Use a new card",
        "model.slpayment.recurring_pay_agreement": "We’ll use the payment details you just provided for subsequent recurrent payments. By submitting, you agree to the <a href=\"https://shopline.tw/about/product_subscription_agreements_en\" target=\"_blank\" rel=\"noopener\">Term Purchase bank card Withholding Agreement.</a>",
        "model.slpayment.security_agreement": "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
        "model.update_credit_card_for_product_subscription.fail": "The payment information for Product Subscription is invalid. Please try again.",
        "model.update_credit_card_for_product_subscription.success": "Credit card information updated successfully",
        "multi_checkout.add_new_store": "Add new store",
        "multi_checkout.cart_tag_unnamed": "(unnamed)",
        "multi_checkout.change.payment_type.modal.cancel": "Cancel",
        "multi_checkout.change.payment_type.modal.confirm": "Update",
        "multi_checkout.change.payment_type.modal.description": "You will need to reselect delivery method and fill out shipping information again once you change the payment type.",
        "multi_checkout.change.payment_type.modal.title": "You are About to Change Payment Type",
        "multi_checkout.checkout.delivery_time.description": "Mô tả cho thời gian giao hàng:",
        "multi_checkout.checkout.destination.title": "Destination Information",
        "multi_checkout.default_store": "Default store",
        "multi_checkout.delivery_attribute": "order",
        "multi_checkout.delivery_section.cod": "Cash on Delivery",
        "multi_checkout.delivery_section.collapse.hint": "Expand",
        "multi_checkout.delivery_section.country.label": "Quốc gia/ Vùng",
        "multi_checkout.delivery_section.delivery_option.label": "Phương thức giao hàng",
        "multi_checkout.delivery_section.empty_delivery_methods": "Không có phương thức thích hợp",
        "multi_checkout.delivery_section.ncod": "Non Cash on Delivery",
        "multi_checkout.delivery_section.payment_type.label": "Payment Type",
        "multi_checkout.delivery_section.title": "Select Payment Type and Delivery Method",
        "multi_checkout.destination_section.address_type.new": "Địa chỉ mới",
        "multi_checkout.destination_section.delivery_type.label": "Selected Delivery Method:",
        "multi_checkout.destination_section.dynamic_fee.hint": "The freight will be displayed after filling in address",
        "multi_checkout.destination_section.pick_store.label": "Tìm cửa hàng",
        "multi_checkout.destination_section.pick_store.store_address": "Address",
        "multi_checkout.destination_section.pick_store.store_code": "Selected Store Code",
        "multi_checkout.destination_section.pick_store.store_name": "Selected Store Name",
        "multi_checkout.destination_section.title": "Destination Information",
        "multi_checkout.items.title": "GIỎ HÀNG",
        "multi_checkout.next_step": "Next",
        "multi_checkout.promotions.title": "giảm giá",
        "multi_checkout.summary_section.check_payment_instructions": "Check Payment Instructions",
        "multi_checkout.summary_section.confirm": "Confirm",
        "multi_checkout.summary_section.delivery_type.label": "Phương thức giao hàng",
        "multi_checkout.summary_section.expand_payment_instructions": "Expand",
        "multi_checkout.summary_section.title": "Chi tiết đơn đặt hàng",
        "order": "Đơn hàng",
        "order.billing_address.same": "Giống như địa chỉ gửi hàng",
        "order.billing_address.title": "Billing Address",
        "order.customer_email": "Địa chỉ email của khách hàng",
        "order.customer_name": "Tên khách hàng",
        "order.customer_phone": "Số điện thoại của khách hàng",
        "order.delivery_address.address_1": "Địa chỉ",
        "order.delivery_address.city": "Thành phố",
        "order.delivery_address.postcode": "Postcode",
        "order.delivery_address.state": "Quận/Bang/Tỉnh",
        "order.delivery_data.consignee_id_no": "Số CMND hoặc Hộ chiếu người nhận",
        "order.delivery_data.location_code": "Mã Cửa hàng",
        "order.delivery_data.location_name": "Tên Cửa hàng",
        "order.delivery_data.recipient_name": "Tên người nhận",
        "order.delivery_data.recipient_phone": "Số điện thoại của người nhận",
        "order.delivery_data.scheduled_delivery_date": "Ngày đến",
        "order.delivery_data.time_slot": "Thời gian Giao hàng",
        "order.delivery_data.time_slot_key": "Khoảng thời gian đến",
        "order.email": "Địa chỉ email",
        "order.invoice.carrier_number": "Hãng vận chuyển",
        "order.invoice.mailing_address": "Địa chỉ",
        "order.invoice.tax_id": "ID Thuế",
        "order.payment_data.credit_card_number": "Số thẻ tín dụng",
        "order.payment_data.cvc": "CVC",
        "order.payment_data.expiry_date": "Ngày hết hạn",
        "order.payment_data.holdername": "Họ tên Chủ thẻ",
        "order.payments.login.confirm": "Please log in and go to pay again or update credit card information!",
        "order_comment_and_message.general_error": "Hệ thống bị lỗi. Vui lòng liên hệ với chủ cửa hàng hoặc thử lại sau.",
        "order_comment_and_message.rate_limit_error": "Bạn đã đạt đến giới hạn tin nhắn hôm nay. Vui lòng tiếp tục vào ngày mai.",
        "orders": "Đơn hàng",
        "orders.action.cancel": "Hủy Đơn hàng",
        "orders.action.checkout": "Đặt hàng",
        "orders.action.confirm": "Xác nhận Đơn hàng",
        "orders.action.ship": "Đánh dấu Đã gửi",
        "orders.actions.title": "Quản lý Tình trạng Đặt hàng",
        "orders.comments.text.name": "Ý kiến",
        "orders.comments.text.placeholder": "Nhập ý kiến cho đơn hàng này",
        "orders.comments.title": "Ý kiến của cửa hàng và khách hàng",
        "orders.coupons": "Xin chúc mừng! Bạn được hưởng các ưu đãi giảm giá sau:",
        "orders.coupons.apply": "Sử dụng Phiếu giảm giá",
        "orders.coupons.invalid": "Rất tiếc, phiếu giảm giá của bạn không hợp lệ.",
        "orders.coupons.invalid.order": "Vui lòng xóa mã phiếu giảm giá không hợp lệ trước khi đặt hàng.",
        "orders.coupons.label": "Mã phiếu giảm giá",
        "orders.coupons.placeholder": "Nhập Mã Phiếu giảm giá",
        "orders.coupons.validation.minamount": "Rất tiếc, đơn hàng của bạn không đạt giá trị cần thiết để sử dụng phiếu giảm giá này",
        "orders.delivery.title": "Thông tin giao hàng",
        "orders.fields.accept_terms": "Bạn đồng ý với Điều khoản Sử dụng và Chính sách Quyền riêng tư của Cửa hàng",
        "orders.fields.accept_terms.validation.required": "Bạn phải đồng ý với các điều khoản và điều kiện để tiếp tục",
        "orders.fields.applied_member_point_redeem_to_cash": "Đã áp dụng điểm thành viên",
        "orders.fields.applied_user_credits": "Đã áp dụng điểm tín dụng",
        "orders.fields.billing_address": "Địa chỉ thanh toán",
        "orders.fields.billto": "Gửi hóa đơn tớ",
        "orders.fields.credits_earned_after_paid": "Credits earned after completed",
        "orders.fields.customer": "Khách hàn",
        "orders.fields.customer.phone": "Số điện thoại của khách hà",
        "orders.fields.customer_name": "Tên Khách hàn",
        "orders.fields.delivery_address": "Địa chỉ Giao hàng",
        "orders.fields.delivery_address.remarks": "Ghi chú Giao hàng",
        "orders.fields.delivery_data.family_mart_freeze.error.locale_code": "Mã Shop là bắt buộc",
        "orders.fields.delivery_data.sl_logistics_yto_store.city_list.error": "Đã xảy ra lỗi trong phương thức giao hàng, vui lòng làm mới trang hoặc <a href=\"/cart\" class=\"alert-highlight\">quay lại trang trước để thay đổi phương thức giao hàng</a>.",
        "orders.fields.delivery_data.sl_logistics_yto_store.family_mart.label": "Family Mart",
        "orders.fields.delivery_data.sl_logistics_yto_store.seven_eleven.label": "7-11",
        "orders.fields.delivery_data.sl_logistics_yto_store.store.label": "Cửa hàng",
        "orders.fields.delivery_data.sl_logistics_yto_store.store_dropdown.error": "Lỗi địa chỉ, vui lòng chọn lại",
        "orders.fields.delivery_data.tw_ezship.location_code.hint": "Tìm cửa hàng",
        "orders.fields.delivery_data.tw_ezship.location_code.label": "Mã Cửa hàng",
        "orders.fields.delivery_data.tw_ezship.location_name.label": "Tên Cửa hàng",
        "orders.fields.delivery_data.tw_ezship.recipient_name.label": "Tên Người nhận",
        "orders.fields.delivery_data.tw_ezship.sn_id.label": "ID Tham chiếu",
        "orders.fields.delivery_data.tw_simple_711.location_code.label": "Mã Cửa hàng 7-11",
        "orders.fields.delivery_data.tw_simple_711.location_name.label": "Tên Cửa hàng 7-11",
        "orders.fields.delivery_data.tw_simple_711.recipient_name.label": "Tên Người nhận",
        "orders.fields.delivery_data.tw_simple_familymart.location_code.label": "Mã Cửa hàng Family Mart",
        "orders.fields.delivery_data.tw_simple_familymart.location_name.label": "Tên Cửa hàng Family Mart",
        "orders.fields.delivery_data.tw_simple_familymart.recipient_name.label": "Tên Người nhận",
        "orders.fields.delivery_description": "Mô tả hàng hóa",
        "orders.fields.delivery_fee": "Phí Giao hàng",
        "orders.fields.delivery_fee_free": "Miễn phí giao hàng",
        "orders.fields.delivery_method": "Phương thức Giao hàng",
        "orders.fields.member_points": "points",
        "orders.fields.options.blacklist.erro": "Sản phẩm của bạn có các phương thức giao hàng hoặc phương thức thanh toán khác nhau. Xin hãy chọn các phương thức hợp lệ khác hoặc đặt hàng cho phù hợp.",
        "orders.fields.options.blacklist.error": "Your products come with different delivery or payment methods. Please choose other valid methods or place orders accordingly.",
        "orders.fields.order_custom_discount": "Giảm giá (tùy chỉnh)",
        "orders.fields.order_date": "Ngà",
        "orders.fields.order_delivery.arrived": "Giao thành công",
        "orders.fields.order_delivery.collected": "Đã nhận",
        "orders.fields.order_delivery.pending": "Chưa hoàn thành",
        "orders.fields.order_delivery.returned": "Trả lại",
        "orders.fields.order_delivery.returning": "Quay trở lại",
        "orders.fields.order_delivery.shipped": "Đã lấy hàng",
        "orders.fields.order_delivery.shipping": "Đang lấy hàng",
        "orders.fields.order_discount": "Giảm giá áp dụng",
        "orders.fields.order_number": "Số Đơn hàng",
        "orders.fields.order_remarks": "Ghi chú Đơn hàn",
        "orders.fields.order_status": "Tình trạn",
        "orders.fields.payment_fee": "Phí Thanh toán",
        "orders.fields.payment_instructions": "Hướng dẫn Thanh toán",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_barcode": "Giới hạn trên với mỗi giao dịch sử dụng Mã vạch là NTD20.000",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_cvs": "Giới hạn trên với mỗi giao dịch sử dụng CVS là NTD20.000",
        "orders.fields.payment_method.validation.limit_exceeded.allpay_webatm": "Giới hạn trên với mỗi giao dịch sử dụng WebATM là NTD30.000",
        "orders.fields.payment_method.validation.limit_lowest.barcode": "Giao dịch không thành công: Giá trị đặt hàng thấp nhất với Thanh toán Mã vạch là NT$30",
        "orders.fields.payment_method.validation.limit_lowest.cvs": "Giao dịch không thành công: Giá trị thanh toán thấp nhất với Thanh toán CVS là NT$30",
        "orders.fields.payment_method.validation.limit_maximum.barcode": "Giao dịch không thành công: Giá trị đặt hàng tối đa với Thanh toán Mã vạch là NT$20000",
        "orders.fields.payment_method.validation.limit_maximum.cvs": "Giao dịch không thành công: Giá trị đặt hàng tối đa với Thanh toán CVS là NT$20000",
        "orders.fields.payment_type": "Loại hình Thanh toá",
        "orders.fields.preorder_item": "Sản phẩm Đặt trướ",
        "orders.fields.product_subscription_period": "{{period}}t",
        "orders.fields.remaining_member_points_without_balance": "Đã áp dụng {{ applied }} điểm",
        "orders.fields.rounding": "Làm tròn",
        "orders.fields.status.cancelled": "Đã huỷ",
        "orders.fields.status.completed": "Đã hoàn tất",
        "orders.fields.status.confirmed": "Đã xác nhậ",
        "orders.fields.status.pending": "Đang xử lý",
        "orders.fields.status.received": "Đã nhậ",
        "orders.fields.status.returned": "Đã trả lạ",
        "orders.fields.status.returning": "Đang trả lạ",
        "orders.fields.status.shipped": "Đã gửi hàn",
        "orders.fields.status.temp": "Đang xử lý",
        "orders.fields.subtotal": "Tổng phụ",
        "orders.fields.total": "Tổng giá trị đơn hàng",
        "orders.fields.user_credits": "điểm tín dụng",
        "orders.general.title": "Chi tiết đơn hàng",
        "orders.index.action.view": "Xem",
        "orders.index.no_records.action": "Mua hàng",
        "orders.index.no_records.description": "Có vẻ bạn chưa từng đặt hàng ở cửa hàng này.",
        "orders.index.no_records.title": "Bạn không có đơn hàng nào.",
        "orders.index.title": "Đơn hàng",
        "orders.invoices.carrier": "Hãng vận chuyển chung",
        "orders.invoices.carrier_type.member": "Thành viên",
        "orders.invoices.carrier_type.mobile_barcode": "Mã vạch Di động",
        "orders.invoices.carrier_type.npc_barcode": "Mã vạch NPC",
        "orders.invoices.get_invoice": "Tôi cần biên lai",
        "orders.invoices.title": "Hóa đơn",
        "orders.member_point.fields.redeemed": "Số điểm dùng để đổi quà tặng",
        "orders.member_point.pos_settled_content": "Điểm thưởng sẽ được nhận sau {{ pending_days }} ngày khi đã hoàn tất đơn hàng tại cửa hàng",
        "orders.member_point.settled_after_content": "Số điểm kiếm được sau khi nhận hàng {{ pending_days }} ngày",
        "orders.member_point.settled_after_order_completed": "Points earned after completed",
        "orders.member_point.unit": "Điểm",
        "orders.notifications.title": "Thông báo Cập nhật Đơn hàng",
        "orders.payment.title": "Thông tin thanh toán",
        "orders.payment_slip.footer": "Thông tin thanh toán bạn đã điền chỉ để kiểm tra đơn đặt hàng và nó được mã hóa an toàn. Bạn có thể hoàn tất thanh toán của mình một cách dễ dàng.",
        "orders.payment_slip.order_info.amount": "Số lượng đơn hàng",
        "orders.payment_slip.order_info.instructions": "Hướng dẫn thanh toán",
        "orders.payment_slip.order_info.read_more": "Xem hướng dẫn thanh toán đầy đủ ",
        "orders.payment_slip.upload_form.hint": "Sau khi xác nhận thanh toán, chúng tôi sẽ sắp xếp giao hàng trong thời gian sớm nhất!",
        "orders.payment_slip.upload_form.image_input.change": "Nhấp để thay đổi hình ảnh",
        "orders.payment_slip.upload_form.image_input.description": "Vui lòng xác nhận rằng hình ảnh rõ ràng và bao gồm 5 chữ số cuối của số giao dịch, thời gian và số tiền chuyển.",
        "orders.payment_slip.upload_form.image_input.error": "Kích thước hình ảnh phải nhỏ hơn 10MB",
        "orders.payment_slip.upload_form.image_input.title": "Tải thông tin chuyển khoản chi tiết lên",
        "orders.payment_slip.upload_form.message": "Điền vào ghi chú trong Thanh toán của bạn",
        "orders.payment_slip.upload_form.message.error": "Không được vượt quá {{ n }} ký tự",
        "orders.payment_slip.upload_form.notification": "Để nhận được thông báo lệnh gần nhất, xin vui lòng đăng ký",
        "orders.payment_slip.upload_form.paid_time": "Chọn thời gian thanh toán",
        "orders.payment_slip.upload_form.title": "Sau khi hoàn thành thanh toán, vui lòng tải lên thông tin thanh toán chuyển khoản chi tiết",
        "orders.payment_slip.uploaded.alert": "Cảm ơn bạn đã tải lên chi tiết chuyển khoản thanh toán, chúng tôi sẽ xác nhận trong thời gian sớm nhất!",
        "orders.payment_slip.uploaded.notification": "Đăng ký để nhận thông tin đặt hàng mới nhất",
        "orders.payment_slip.uploaded.order_link": "Xem đơn hàng",
        "orders.payment_slip.uploaded.paid_time": "Thời gian thanh toán:",
        "orders.payment_slip.uploaded.title": "Dưới đây là chi tiết dưới đây chuyển của bạn",
        "orders.payment_slip.uploaded.upload_time": "Cập nhật Proof Thời gian:",
        "orders.payment_slip.uploaded_without_login.hint": "Hãy đăng nhập để xem chi tiết",
        "orders.payment_slip.uploaded_without_login.title": "Cảm ơn bạn! Chi tiết chuyển khoản thanh toán đã được tải lên cho đơn đặt hàng này",
        "orders.products.title": "Thông tin Sản phẩm",
        "orders.promotion_coupons.placeholder": "Nhập Mã Phiếu giảm giá",
        "orders.promotion_type.bundle_amount": "Giá gộp",
        "orders.promotion_type.bundle_gift": "Giá gộp",
        "orders.promotion_type.bundle_group": "Nhóm gộp",
        "orders.promotion_type.bundle_group_amount": "Nhóm gộp",
        "orders.promotion_type.bundle_group_gift": "Nhóm gộp",
        "orders.promotion_type.bundle_group_percentage": "Nhóm gộp",
        "orders.promotion_type.bundle_percentage": "Giá gộp",
        "orders.promotion_type.bundle_pricing": "Giá gộp",
        "orders.promotion_type.buyandget_free": "Buy X Get Y",
        "orders.promotion_type.buyandget_percentage": "Buy X Get Y",
        "orders.promotion_type.buyandget_pricing": "Buy X Get Y",
        "orders.promotion_type.coupon": "Voucher",
        "orders.promotion_type.credit_reward": "Reward Credits",
        "orders.promotion_type.custom_discount": "Giảm giá tùy chỉnh",
        "orders.promotion_type.earn_purchase_points": "Earning Points",
        "orders.promotion_type.free_shipping": "Free Shipping Promotion",
        "orders.promotion_type.member_point_redeem_gift": "Chiến dịch tích điểm",
        "orders.promotion_type.membership_offer": "Ưu đãi thành viên",
        "orders.promotion_type.point_reward": "Reward Points",
        "orders.promotion_type.promotion": "Khuyến mãi",
        "orders.promotion_type.reward_credit": "Thưởng điểm tín dụng",
        "orders.reward_credit.accumulated_auto_reward": "Mỗi {{ credit_threshold }} được tặng {{ credit_value }} điểm tín dụng",
        "orders.reward_credit.auto_reward": "Mua đủ {{ credit_threshold }} tặng {{ credit_value }} điểm tín dụng",
        "orders.reward_credit.balance": "Mua thêm {{ auto_reward_balance }} để nhận ưu đãi",
        "orders.reward_credit.earned_after_order_completed_faq": "You can earn the points after the order is completed and use them on your next order. Please note that the points are calculated based on the amount after the discount.",
        "orders.reward_credit.faq": "Bạn sẽ nhận được điểm tín dụng sau khi thanh toán đơn hàng và có thể áp dụng nó vào lần mua hàng tiếp theo.",
        "orders.reward_credit.value": "{{ credit_value }} điểm tín dụng",
        "orders.reward_point.earned_after_order_completed_faq": "You can earn the points after the order is completed and use them on your next order. Please note that the points are calculated based on the amount after the discount.",
        "orders.reward_point.faq": "You can earn the points after the order is completed and use them on your next purchase.",
        "orders.reward_point.value": "{{ point_value }} points",
        "orders.show.check_order.description": "Bạn bạn thể xem hoặc huỷ đơn hàng tại <a href=\"{{pagePath}}\">Trung tâm thành viên> Đơn hàng</a>",
        "orders.show.check_order.title": "Kiểm tra đơn hàng",
        "orders.show.customer_cancel_order.button.cancel": "Hủy đơn hàng",
        "orders.show.customer_cancel_order.button.ok": "OK",
        "orders.show.customer_cancel_order.confirm.description.integrated": "Rất tiếc khi thấy bạn hủy. Vui lòng cho chúng tôi biết lý do, chúng tôi sẽ cố gắng làm cho trải nghiệm mua sắm tiếp theo của bạn tốt hơn! Tiền sẽ được hoàn sau khi hủy.",
        "orders.show.customer_cancel_order.confirm.description.non_integrated": "Rất tiếc khi thấy bạn hủy. Vui lòng cho chúng tôi biết lý do, chúng tôi sẽ cố gắng làm cho trải nghiệm mua sắm tiếp theo của bạn tốt hơn! Có thể sẽ mất vài ngày để xử lý hoàn tiền, vui lòng kiên nhẫn chờ đợi.",
        "orders.show.customer_cancel_order.confirm.failed.description": "Nếu thử lại không thành công, vui lòng liên hệ với chúng tôi tại \"Bình luận của cửa hàng và khách hàng\" bên dưới.",
        "orders.show.customer_cancel_order.confirm.failed.title": "Rất tiếc! Việc hủy đã thất bại. Vui lòng thử lại.",
        "orders.show.customer_cancel_order.confirm.loading.description": "Vui lòng đợi trong giây lát. Đừng rời khỏi hoặc quay lại trang trước.",
        "orders.show.customer_cancel_order.confirm.loading.title": "Đang xử lý",
        "orders.show.customer_cancel_order.confirm.success.description": "Thông báo qua email sẽ được gửi sau khi hủy thành công",
        "orders.show.customer_cancel_order.confirm.success.title": "Yêu cầu hủy được gửi.",
        "orders.show.customer_cancel_order.confirm.title": "Bạn có chắc chắn muốn hủy bỏ?",
        "orders.show.customer_cancel_order.reasons.change_item": "Muốn thay đổi mục mua hàng",
        "orders.show.customer_cancel_order.reasons.change_mind": "Thay đổi suy nghĩ của bạn",
        "orders.show.customer_cancel_order.reasons.default": "Vui lòng chọn một lý do để hủy bỏ",
        "orders.show.customer_cancel_order.reasons.expensive_price": "Giá đắt hơn những nơi khác",
        "orders.show.customer_cancel_order.reasons.hint": "Lý do hủy bỏ",
        "orders.show.customer_cancel_order.reasons.incorrect_customer_info": "Nhập thông tin giao hàng hoặc thanh toán không chính xác",
        "orders.show.customer_cancel_order.reasons.other": "Khác",
        "orders.show.customer_cancel_order.reasons.other.placeholder": "Xin vui lòng cho chúng tôi biết lý do để chúng tôi có thể làm tốt hơn vào lần tới!",
        "orders.show.customer_cancel_order.reasons.repeat_purchase": "Đơn hàng bị trùng",
        "orders.show.customer_cancel_order.reasons.wait_too_long": "Đợi quá lâu để nhận được hàng",
        "orders.show.message.shipped.description": " ",
        "orders.show.message.shipped.title": "Sản phẩm của bạn đã được gửi đi",
        "orders.show.message.thankyou.description": " ",
        "orders.show.message.thankyou.title": "Cảm ơn bạn đã đặt hàng",
        "orders.show.thankyou.continue": "Tiếp tục mua sắm ngay!",
        "payment.action.confirm": "Xác nhận",
        "payment.cc.cashier.footer": "The payment service is powered by SHOPLINE Payments",
        "payment.cc.cvc": "CVC",
        "payment.cc.cvc.hint": "Mã bảo mật gồm 3 chữ số thường thấy ở mặt sau thẻ.",
        "payment.cc.cvc.placeholder": "CVC",
        "payment.cc.expirydate": "Ngày hết hạn",
        "payment.cc.expirydate.placeholder": "Tháng/Năm",
        "payment.cc.fields.accept_terms": "Tôi đồng ý với Điều khoản sử dụng và Chính sách Quyền riêng tư",
        "payment.cc.fields.accept_terms.validation.required": "Bạn phải đồng ý với các Điều khoản và Điều kiện để tiếp tục",
        "payment.cc.holdername": "Tên Chủ thẻ",
        "payment.cc.holdername.hint": "Giống như họ tên đầy đủ trên thẻ",
        "payment.cc.holdername.placeholder": "Tên Chủ thẻ",
        "payment.cc.number": "Số thẻ tín dụng (Visa / Master)",
        "payment.cc.number.placeholder": "Số Thẻ tín dụng (không có dấu cách)",
        "payment.cc.tw.cashier.footer": "The payment is powered by SHOPLINE Payments. SHOPLINE Payments is PCI-DSS Level 1 validated and supports the secure use of domestic ＆ international credit cards.",
        "payment.cc.update.instructions": "Vui lòng nhập thẻ tín dụng bên dưới để cập nhật",
        "payments.fields.types.allpay_barcode": "Mã vạch qua Allpay",
        "payments.fields.types.allpay_credit": "Thẻ tín dụng qua Allpay",
        "payments.fields.types.allpay_cvs": "CVS qua Allpay",
        "payments.fields.types.allpay_webatm": "WebATM qua Allpay",
        "payments.fields.types.asiapay": "Thẻ tín dụng qua Asiapa",
        "payments.fields.types.bank_transfer": "Chuyển khoản Ngân hàng",
        "payments.fields.types.cash_on_delivery": "Hàng đến trả tiền",
        "payments.fields.types.credit_card": "Thẻ tín dụng",
        "payments.fields.types.custom": "Tùy chỉnh",
        "payments.fields.types.esun": "Thẻ tín dụng Esu",
        "payments.fields.types.ezship": "Thanh toán khi đến nhập hàng tại cửa hàng qua ezShip",
        "payments.fields.types.free_checkout": "Thanh toán miễn phí",
        "payments.fields.types.paypal": "Thẻ tín dụng hoặc Paypal",
        "payments.fields.types.paypal_express": "Thẻ tín dụng hoặc Paypal",
        "payments.fields.types.prizm": "Thẻ tín dụng Visa / Master",
        "paypal.language": "en_US",
        "porduct_sales_sold_count.max": "Sold <b>90M+</b>",
        "porduct_sales_sold_count.than_10": "Sold <b>{{count}}+</b>",
        "porduct_sales_sold_count.than_100": "Sold <b>{{count}}+</b>",
        "porduct_sales_sold_count.than_1000": "Sold <b>{{digit4}}K+</b>",
        "porduct_sales_sold_count.than_10000": "Sold <b>{{digit4}}K+</b>",
        "porduct_sales_sold_count.than_100000": "Sold <b>{{digit4}}K+</b>",
        "porduct_sales_sold_count.than_1000000": "Sold <b>{{digit7}}M+</b>",
        "porduct_sales_sold_count.than_10000000": "Sold <b>{{digit7}}M+</b>",
        "product.add_to_cart": "THÊM VÀO GIỎ HÀNG",
        "product.add_to_cart_fail": "Giỏ hàng của bạn đã đầy!",
        "product.addon_products.add_to_cart.hint": "Sản phẩm đã được thêm vào giỏ hàng thành công",
        "product.addon_products.errors.addon_product_out_of_stock": "Sản phẩm bổ sung không có đủ hàng",
        "product.addon_products.errors.larger_addon_product": "Số lượng sản phẩm bổ sung không được nhiều hơn số lượng sản phẩm chính",
        "product.addon_products.errors.main_product_out_of_stock": "Sản phẩm chính không có đủ hàng",
        "product.addon_products.errors.out_of_stock": "Sản phẩm bổ sung {{title}} không có đủ hàng.",
        "product.addon_products.errors.reached_max_purchase_quantity": "Giới hạn {{ message }} mỗi đơn hàng.",
        "product.addon_products.label": "Sản phẩm Bổ sung",
        "product.addon_products.tips.limit_exceed": "Khi bạn điều chỉnh số lượng, số lượng của sản phẩm bổ sung không thể lớn hơn số lượng của sản phẩm chính.",
        "product.amazon_product_review.show_more": "Show more",
        "product.available_time_info.end.1": "Product will be unavailable on ",
        "product.available_time_info.end.2": "",
        "product.available_time_info.start.1": "Product available from ",
        "product.available_time_info.start.2": "",
        "product.available_time_over": "HẾT GIỜ",
        "product.bundle_group_products.label": "Nhóm gộp",
        "product.bundled_products.label": "Giá gộp",
        "product.buy_now": "MUA NGAY",
        "product.buy_now.preorder.hint": "Now taking pre-orders",
        "product.buy_together": "MUA TIẾP CẬN",
        "product.buyandget.label": "Buy X Get Y",
        "product.coming_soon": "\"HÀNG SẮP VỀ",
        "product.gift.label": "Free Gifts",
        "product.member_only": "Member Only",
        "product.out_of_stock": "Hết hàn",
        "product.page.add_to_cart_count": "Đã thêm <span class=\"order-detail-count\">{{count}}</span> sản phẩm",
        "product.page.quantity": "Số lượng",
        "product.page.subtotal": "Tổng phụ",
        "product.page.title.product-info": "Sản phẩm",
        "product.page.unit_price": "Đơn giá",
        "product.preorder_limit.hint": "The purchase quantity includes both in-stock and preordered items.",
        "product.product_review.no_review": "Sản phẩm này chưa có đánh giá nào",
        "product.product_review.out_of_5_stars": "sao",
        "product.product_review.rating_source_amazon": "Nguồn đánh giá: Amazon",
        "product.product_review.rating_source_shopline": "Nguồn đánh giá: Trên cửa hàng này",
        "product.product_review.reviews": "Đánh giá",
        "product.product_review.stars": "sao",
        "product.set.open_variation": "View product details",
        "product.store_stock.check_stock": "Check available pickup stores",
        "product.subscription_product.label": "Subscription Product",
        "product.tier_member_only": "{{tierName}} Only",
        "product.view_less": "Hide content",
        "product.view_more": "Show more",
        "product_review_comments.modal.content.character": "Word count",
        "product_review_comments.modal.content.character_hint": "At least {{ min_length }} words",
        "product_review_comments.modal.content.img": "Image",
        "product_review_comments.modal.content.img_hint": "Upload at least one image",
        "product_review_comments.modal.content.no_limit.character": "No word count requirement",
        "product_review_comments.modal.content.no_limit.img": "No requirement",
        "product_review_comments.modal.content.no_limit.time": "No time limit",
        "product_review_comments.modal.content.time": "Review time",
        "product_review_comments.modal.content.time_hint": "Submit review within {{ deadline_days }} days of order completion",
        "product_review_comments.modal.title": "Review Reward Rules",
        "product_review_comments.orders.back_to_my_account": "< Quay lại Tài khoản của tôi",
        "product_review_comments.orders.back_to_the_store": "Quay lại cửa hàng",
        "product_review_comments.orders.comment": "Nhận xét",
        "product_review_comments.orders.comment_placeholder": "(tuỳ chọn) Bạn có hài lòng với trải nghiệm mua sắm vừa rồi? Hãy chia sẻ suy nghĩ với chúng tôi!",
        "product_review_comments.orders.completed_all_reviews": "Chúc mừng! Bạn đã hoàn thành tất cả đánh giá!",
        "product_review_comments.orders.empty.title": "No products to reviews",
        "product_review_comments.orders.finished_review.desc.1": "Earn {{ value }} {{ type }} by submitting a review now!",
        "product_review_comments.orders.finished_review.desc.2": "Earn {{ value }} {{ type }} by submitting a review before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.3": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words!",
        "product_review_comments.orders.finished_review.desc.4": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.5": "Earn {{ value }} {{ type }} by submitting a review with an image!",
        "product_review_comments.orders.finished_review.desc.6": "Earn {{ value }} {{ type }} by submitting a review with an image before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.7": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words and an image!",
        "product_review_comments.orders.finished_review.desc.8": "Earn {{ value }} {{ type }} by submitting a review with {{ min_length }}+ words and an image before {{ deadline }}!",
        "product_review_comments.orders.finished_review.desc.member_point": "If it meets the campaign requirements, you will receive {{ value }} member points later.",
        "product_review_comments.orders.finished_review.desc.user_credit": "If it meets the campaign requirements, you will receive {{ value }} store credits later.",
        "product_review_comments.orders.finished_review.title": "Thank you for your review!",
        "product_review_comments.orders.max_length_of_characters": "Tối đa 2000 ký tự",
        "product_review_comments.orders.order_id": "ID đơn hàng:",
        "product_review_comments.orders.orders_to_view": "Đơn hàng cần xem xét",
        "product_review_comments.orders.purchased_date": "Ngày mua hàng:",
        "product_review_comments.orders.rate_other_order": "Đánh giá đơn hàng khác",
        "product_review_comments.orders.review": "Gửi",
        "product_review_comments.orders.send": "Gửi",
        "product_review_comments.orders.upload_image": "Tải hình ảnh (tối đa 9 ảnh)",
        "product_review_comments.orders.write_a_review": "Viết đánh giá",
        "product_review_entry.review_button_text": "Write a review",
        "product_review_entry.review_description_content": "Enjoyed what you bought? Please give us a thumbs-up review!",
        "product_review_entry.review_description_title": "We are waiting for your review!",
        "product_review_entry.review_description_title.member_point": "We're waiting for your review! Review now and earn {{ value }} points!",
        "product_review_entry.review_description_title.user_credit": "We're waiting for your review! Review now and earn {{ value }} store credits!",
        "product_set.add_to_cart": "THÊM VÀO GIỎ HÀNG",
        "product_set.add_to_set": "Thêm vào bộ sản phẩm",
        "product_set.build": "Chỉnh sửa bộ sản phẩm",
        "product_set.exceed_limit": "Vượt quá giới hạn nhập hàng bộ sản phẩm, vui lòng điều chỉnh số lượng",
        "product_set.items_needed": "Còn thiếu <span class=\"highlight-label\">{{ quantity }}</span> sản phẩm",
        "product_set.items_needed.diff": "Đã chọn {{ currentQuantity }} sản phẩm, thêm <span class=\"highlight-label\">{{ stillNeedQuantity }}</span> sản phẩm để nhận khuyến mãi từ bộ sản phẩm ",
        "product_set.items_needed.hint": "Thêm <span class=\"highlight-label\">{{ quantity }}</span> sản phẩm để hoàn thành bộ sản phẩm",
        "product_set.items_selected": "Đã chọn <span class=\"highlight-label\">{{ quantity }}</span> sản phẩm",
        "product_set.no_items_selected": "Không có sản phẩm được chọn",
        "product_set.not_enough_stock": "Thiếu hàng tồn kho, vui lòng điều chỉnh số lượng sản phẩm.",
        "product_set.not_enough_stock.please_remove": "Thiếu hàng tồn kho, vui lòng loại bỏ sản phẩm này.",
        "product_set.please_select": "Vui lòng chọn sản phẩm",
        "product_set.quantity": "Số lượng bộ sản phẩm",
        "product_set.quantity_label.qualified": "Đã chọn {{ quantity }} sản phẩm",
        "product_set.quantity_label.unqualified": "Còn thiếu {{ quantity }} sản phẩm",
        "product_set.quick_cart.add_to_set": "Thêm bộ sản phẩm",
        "product_set.reach_limit": "Đã đạt đến giới hạn mua hàng",
        "product_set.reach_limit.congrats": "Đã chọn <span class=\"highlight-label\">{{ quantity }}</span> sản phẩm, chúc mừng bạn đã nhận được khuyến mãi từ bộ sản phẩm",
        "product_set.set_includes": "Bộ sản phẩm bao gồm:",
        "product_set.sold_out": "Không đủ hàng tồn kho",
        "product_set.special_offer": "Ưu đãi bộ sản phẩm",
        "product_set.subtitle.qualified": "Bạn đã đủ điều kiện để giảm giá. Thêm bộ sản phẩm vào giỏ hàng!",
        "product_set.subtitle.unqualified": "Thêm ngay các sản phẩm sau đây; chọn thêm <span class=\"highlight-label\">{{ quantity }}</span> sản phẩm để hoàn thành bộ sản phẩm và thêm vào giỏ hàng",
        "products.category.advance_filter.apply": "Áp dụng lọc",
        "products.category.advance_filter.clear": "Bỏ lựa chọn",
        "products.category.advance_filter.clear_all": "Xoá tất cả",
        "products.category.advance_filter.placeholder.max_price": "Số tiền tối đa",
        "products.category.advance_filter.placeholder.min_price": "Số tiền tối thiểu",
        "products.category.advance_filter.show_less": "Hiện ít hơn",
        "products.category.advance_filter.show_more": "Hiển thị thêm",
        "products.category.advance_filter.tag.max_price": "≤ {{ max_price }}",
        "products.category.advance_filter.tag.min_price": "≥ {{ min_price }}",
        "products.category.advance_filter.tag.price_range": "{{ min_price }} ~ {{ max_price }}",
        "products.category.advance_filter.title": "Lọc",
        "products.category.advance_filter.type.brand": "Thương hiệu",
        "products.category.advance_filter.type.color": "Màu sắc",
        "products.category.advance_filter.type.material": "Vật chất",
        "products.category.advance_filter.type.price": "Khoảng giá ({{ currency }})",
        "products.category.advance_filter.type.size": "Kích thước",
        "products.message.button_cancel": "Hủy",
        "products.message.button_ok": "OK",
        "products.message.title": "Bạn có chắc bạn muốn xóa sản phẩm này không?",
        "products.purchase_limit_hint": "Giới hạn {{limit}} sản phẩm cho mỗi khách hàng",
        "products.purchase_limit_hint_can_not_purchase": "Giới hạn {{limit}} sản phẩm cho mỗi khách hàng. Sản phẩm đã đạt số lượng giới hạn.",
        "products.quick_cart.add_to_cart": "THÊM VÀO GIỎ HÀNG",
        "products.quick_cart.insufficient_point": "Not enough points, please remove some gifts",
        "products.quick_cart.low_stock_hint": "Không đủ hàng.\n Xin hãy điều chỉnh số lượng.",
        "products.quick_cart.message": "TIN NHẮN",
        "products.quick_cart.messagetobuy": "Vui lòng gửi tin nhắn cho chủ cửa hàng về chi tiết đơn hàng.",
        "products.quick_cart.out_of_number_hint": "Hết hàng/số lượng sản phẩm đặt trước",
        "products.quick_cart.out_of_stock": "ĐÃ BÁN HẾT",
        "products.quick_cart.out_of_stock_hint": "Không đủ hàng.\n Sản phẩm của bạn không được thêm vào giỏ hàng.",
        "products.quick_cart.preorder_now": "ĐẶT TRƯỚC NGAY",
        "products.quick_cart.quantity": "Số lượng",
        "products.quick_cart.quantity_invalid": "",
        "products.quick_cart.quantity_of_stock_hint": "Chỉ còn lại {{message}} sản phẩm.",
        "products.quick_cart.reached_max_purchase_quantity": "Giới hạn {{ message }} mỗi đơn hàng.",
        "products.quick_cart.show_more": "Thêm chi tiết",
        "products.variant_selector.hide": "Ẩn ",
        "products.variant_selector.view_other_variations": "Xem các tuỳ chọn {{count}} khác",
        "promotions.available_platform.app": "App",
        "promotions.available_platform.ec": "Online Store",
        "promotions.available_platform.only": "{{platform}} Only",
        "promotions.available_platform.retail": "Retail Store",
        "promotions.available_platform.selected_retail": "Selected Stores",
        "promotions.exclude.items.hint.member_point": "Giảm giá điểm",
        "promotions.exclude.items.hint.member_tier": "Giảm giá % cho thành viên",
        "promotions.exclude.items.hint.order_discount": "Giảm giá trên đơn hàng",
        "promotions.exclude.items.hint.reward_campaign": "Order-level Reward Campaign",
        "promotions.exclude.items.hint.title": "Sản phẩm giá sốc sẽ không được áp dụng với:",
        "promotions.exclude.items.hint.user_credit": "Sử dụng điểm tín dụng cửa hàng",
        "promotions.page.available_platform": "Available Channels: ",
        "promotions.page.display_local_timezone": "Hiển thị theo múi giờ của bạn<br/>(GMT{{offset}})",
        "promotions.page.end_at": "Kết thúc vào <b class=\"local-datetime\">{{date}}</b>",
        "promotions.page.first_purchase_only": "<b>1st Purchase</b> Only",
        "promotions.page.first_purchase_only.with_platform": "<b>1st Purchase</b> Only in {{platform}}",
        "promotions.page.gift_sold_out_tag": "SOLD OUT",
        "promotions.page.gifts_sold_out": "All free gifts have been claimed.",
        "promotions.page.redeem_gift.end_at": "Campaign ends on <b class=\"local-datetime\">{{date}}</b>",
        "promotions.page.redeem_gift.start_at": "Campaign begins on <span class=\"local-datetime\">{{date}}</span>",
        "promotions.page.start_at": "Bắt đầu vào <span class=\"local-datetime\">{{date}}</span>",
        "promotions.page.term.confirm": "Xác nhận",
        "promotions.page.term.default": "＊ Khuyến mãi áp dụng tùy theo tổng giá trị đơn hàng trong giỏ hàng.\n＊ Khách hàng nên chọn phương thức thanh toán và giao hàng hợp lệ để được hưởng khuyến mãi.\n＊ Với chương trình khuyến mãi chỉ dành cho thành viên, khách hàng nên đăng nhập để thanh toán.",
        "promotions.page.term.title": "Điều khoản và điều kiện",
        "promotions.page.view_gifts": "View free gifts",
        "promotions.section.discount_percentage.caption": "giảm giá {{ value }}%",
        "promotions.section.discount_summary.content": "{{ benefits }}{{ criteria }}",
        "promotions.section.discount_summary.criteria.bundle_amount": "Sản phẩm được chọn: Mua {{ itemCount }} mặt hàng giảm giá {{ discountvalue }}",
        "promotions.section.discount_summary.criteria.bundle_gift": "Sản phẩm được chọn: Mua {{ itemCount }} mặt hàng tặng {{ discountvalue }} phần quà ({{ giftMame }})",
        "promotions.section.discount_summary.criteria.bundle_group": "Sản phẩm được chọn: Mua {{ red_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm A</span> và {{ green_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm B</span> với giá {{ total }}",
        "promotions.section.discount_summary.criteria.bundle_group.is_accumulated": " Mua nhiều hơn, tiết kiệm hơn!",
        "promotions.section.discount_summary.criteria.bundle_group.is_not_accumulated": " Limited offer for your first set.",
        "promotions.section.discount_summary.criteria.bundle_group_amount": "Sản phẩm được chọn: Mua {{ red_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm A</span> và {{ green_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm B</span> giảm giá {{ total }}",
        "promotions.section.discount_summary.criteria.bundle_group_gift": "Sản phẩm được chọn: : Mua {{ red_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm A</span> và {{ green_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm B</span> tặng {{ total }} phần quà ({{ giftName }})",
        "promotions.section.discount_summary.criteria.bundle_group_percentage": "Sản phẩm được chọn: Mua {{ red_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm A</span> và {{ green_count }} trong <span class=\"bundle-group-label bundle-group-red\">Nhóm B</span> giảm giá {{ total }}%",
        "promotions.section.discount_summary.criteria.bundle_percentage": "Sản phẩm được chọn: Mua {{ itemCount }} mặt hàng với giá {{ discountvalue }}",
        "promotions.section.discount_summary.criteria.bundle_pricing": "指定商品： 任選 {{ itemCount }} 件 共 {{ discountValue }}",
        "promotions.section.discount_summary.criteria.scope_discounted_products": "<b>Sản phẩm Nhất định</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_products.content": " khi mua các <b>Sản phẩm Nhất định</b> trên <b>{{ condition_value }}</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_subtotal": "<b>Toàn bộ Đơn hàng</b>",
        "promotions.section.discount_summary.criteria.scope_discounted_subtotal.content": " khi mua trên <b>{{ condition_value }}</b>",
        "promotions.section.discount_summary.criteria.type_quantity": "{{ count }} sản phẩm",
        "promotions.section.discount_summary.discount_value": "<b>{{ type == \"amount\" ? Currency : \"\"  }}{{ value }}{{ type == \"percentage\" ? \"%\":\"\"  }}</b>",
        "promotions.section.discount_summary.set.on_item": "Được giảm giá <b>{{ discount_value }}</b> cho <b>các Sản  phẩm Nhất định</b>",
        "promotions.section.discount_summary.set.on_order": "Được giảm giá <b>{{ discount_value }}</b> cho <b>Toàn bộ Đơn hàng</b>",
        "purchase_limit_hint.purchasable": "Giới hạn {{limit}} sản phẩm cho mỗi khách hàng. Bạn chỉ có thể mua được {{purchasable_qty}} sản phẩm nữa.",
        "recaptcha.language": "vi",
        "redirect.go_home_in_seconds": "Quay lại Trang chủ sau {{seconds}} giây",
        "return_order.back_to_order_detail": "Back to order information page",
        "return_order.confirmation": "Return Order Confirmation",
        "return_order.confirmation.refund_note": "The acutal refund amount will be displayed on <a href=\"{{ link }}\">Return Order Information Page</a>.",
        "return_order.confirmation.refund_question": "Please <a id=\"js-contact-us\">Contact Us</a> if you have any question.",
        "return_order.coninue_shopping": "Continue Shopping",
        "return_order.delivery_status.arrived": "Arrived",
        "return_order.delivery_status.no_return": "Return not required",
        "return_order.delivery_status.pending": "Returning",
        "return_order.delivery_status.return_collected": "Returned",
        "return_order.delivery_status.returned": "Returned",
        "return_order.delivery_status.returning": "Returning",
        "return_order.detail.apply_date": "Apply Date",
        "return_order.detail.confirmation_emailed": "An return order confirmation email will be sent to below email",
        "return_order.detail.order_submitted": "Your return order has been submitted!",
        "return_order.detail.return_order_no": "Return Order No.",
        "return_order.fill_infomation": "Fill Return Information",
        "return_order.form.agree_return_policy": "I agree to the shop's <a href=\"{{ link }}\" target=\"_blank\" rel=\"noopener\">Return Policy</a>",
        "return_order.form.submit": "Confirm Return Order",
        "return_order.form.validation": "You must agree with the return policy",
        "return_order.inspect.status": "Return Inspection Status",
        "return_order.inspect.status.fail": "Fail",
        "return_order.inspect.status.no_inspect": "Inspection not required",
        "return_order.inspect.status.pass": "Pass",
        "return_order.inspect.status.pending": "Uninspected",
        "return_order.order_number": "Order Number",
        "return_order.payment_record.pending": "Pending",
        "return_order.payment_status.pending": "Pending",
        "return_order.payment_status.refunded": "Refunded",
        "return_order.popup.failed.confirm": "OK",
        "return_order.popup.failed.content": "This shipping method cannot exceed TWD {{ amount }}. Please change the logistics again.",
        "return_order.popup.failed.title": "Return Failed !",
        "return_order.prcie_amount": "Subtotal",
        "return_order.product_name": "Product Name",
        "return_order.quantity": "Quantity",
        "return_order.refund.amount": "Refund Amount",
        "return_order.refund.date": "Refund Date",
        "return_order.refund.record": "Refund Record",
        "return_order.return.total": "Return total",
        "return_order.return_delivery.delivery_option": "Return Delivery Type",
        "return_order.return_delivery.destination": "Shipping Destination",
        "return_order.return_delivery.info": "Delivery Details",
        "return_order.return_delivery.optional": "Optional",
        "return_order.return_delivery.receiver_address": "Return Address",
        "return_order.return_delivery.receiver_name": "Return Name",
        "return_order.return_delivery.receiver_phone": "Return Phone",
        "return_order.return_delivery.status": "Return Delivery Status",
        "return_order.return_payment.bank_account": "Bank Name & Account",
        "return_order.return_payment.bank_transfer_placeholder": "812 TSBank xxxxxxxxxxxx",
        "return_order.return_payment.bank_transfer_return": "Provide refund account",
        "return_order.return_payment.custom_return": "Others（Please contact us for refund details）",
        "return_order.return_payment.info": "Refund Details",
        "return_order.return_payment.payment_option": "Return Payment Type",
        "return_order.return_payment.status": "Refund Status",
        "return_order.return_quantity": "Return Quantity",
        "return_order.return_reason": "Return Reason",
        "return_order.return_reason.admin_return_order": "Return By Merchant",
        "return_order.return_reason.broke_during_delivery": "Parcel damaged on arrival",
        "return_order.return_reason.not_expected": "Not as expected",
        "return_order.return_reason.other": "Others",
        "return_order.return_reason.return_remark": "Please specify in additional note",
        "return_order.return_reason.return_remark_placeholder": "60 characters",
        "return_order.return_reason.wrong_item": "Incorrect item received",
        "return_order.return_reason.wrong_variation": "Size issue",
        "return_order.select_return_product": "Select Return Product",
        "return_order.status": "Return Order Status",
        "return_order.status.cancelled": "Return cancelled",
        "return_order.status.completed": "Return completed",
        "return_order.status.confirmed": "Return confirmed",
        "return_order.status.pending": "Return in progress",
        "return_order.unit_price": "Unit Price",
        "save_fields.customer_info.birthday": "Sinh nhật khách hàng",
        "saved_stores.update.failure": "Cập nhật không thành công, vui lòng thử lại",
        "session.forget_passowrd.check_phone.error": "Số di động không chính xác, vui lòng kiểm tra lại",
        "session.forget_passowrd.error": "Email or mobile number is invalid",
        "session.forgot_password": "Quên mật khẩ",
        "session.login.success": "Logged in successfully",
        "session.mobile_center.check_phone.error": "Số di động này đã được dùng",
        "session.mobile_signup.check_mobile.go_back.1": "bạn có thể",
        "session.mobile_signup.check_mobile.go_back.2": "quay lại",
        "session.mobile_signup.check_mobile.go_back.3": "để sửa lại số di động nếu bị sai",
        "session.mobile_signup.check_mobile.go_back.3.simplified": "to correct mobile number",
        "session.mobile_signup.check_mobile.send_code": "Gửi mã kiểm tra cho tôi",
        "session.mobile_signup.check_mobile.title": "Xin hãy kiểm tra xem số điện thoại di động của bạn có đúng không bên dưới, tin nhắn sms sẽ được gửi tới số di động này",
        "session.mobile_signup.check_mobile.your_number": "Số điện thoại di động của bạn",
        "session.mobile_signup.check_mobile.your_number.hint": "Vui lòng nhập số điện thoại di động ở Đài Loan (bắt đầu bằng 09)",
        "session.mobile_signup.go_back": "Back",
        "session.mobile_signup.input_code.hint": "Xin hãy nhập mã kiểm tra bạn đã nhận",
        "session.mobile_signup.input_code.hint.simplified": "Please input check code you received",
        "session.mobile_signup.input_code.placeholder": "Check code",
        "session.mobile_signup.input_code.resend": "Gửi lại sms mã kiểm tra tới số di động của tôi",
        "session.mobile_signup.input_code.resend.countdown": "Gửi lại sms mã kiểm tra tới số di động của tôi ({{resendCountdown}} giây)",
        "session.mobile_signup.input_code.resend.countdown.simplified": "Resend check code ({{resendCountdown}} sec)",
        "session.mobile_signup.input_code.resend.simplified": "Resend check code",
        "session.mobile_signup.input_code.submit": "Đi",
        "session.mobile_signup.recaptcha.checkbox.error": "Verification code will be sent after you pass reCAPTCHA",
        "session.mobile_signup.recaptcha.load.failure": "Google reCAPTCHA failed to load. Please ensure your network connection is stable and restart the app.",
        "session.mobile_signup.recaptcha.token.failure": "An error occurred. Please ensure your network connection is stable and restart the app.",
        "session.signin.facebook": "Đăng nhập Facebook",
        "session.signin.submit": "Đăng nhập",
        "session.signin.title": "Đăng nhập",
        "session.signup.facebook": "Đăng nhập Faceboo",
        "session.signup.success": "Sign up successful. You're now logged in.",
        "session.signup.title": "Đăng ký",
        "session.terms": "Bằng việc tiếp tục, bạn đồng ý với các điều khoản và điều kiện của chúng tôi",
        "session.terms.facebook": "Đăng ký bằng Faceboo",
        "sessions.or": "HOẶ",
        "sms_messenger_checkbox.subscribe": "Gửi qua tin nhắn",
        "store_credits.bulk_imported": "Manually added",
        "store_credits.credit_balance": "Số dư điểm",
        "store_credits.credit_history": "Lịch sử sử dụng điểm",
        "store_credits.fields.auto_reward": "  gets reward credits",
        "store_credits.fields.auto_reward_prefix": "Order ",
        "store_credits.fields.balance": "Số dư điểm",
        "store_credits.fields.birthday_credit": "Điểm Sinh nhật",
        "store_credits.fields.date": "Ngày",
        "store_credits.fields.display.never_expired": "Vô thời hạn",
        "store_credits.fields.expiry_date": "Ngày hết hạn",
        "store_credits.fields.member_info_quick_completion_credit": "Phần thưởng điểm tín dụng hoàn thành hồ sơ thành viên",
        "store_credits.fields.member_referral_credit": "Refer new member to sign up",
        "store_credits.fields.never_expires": "Không bao giờ hết hạn",
        "store_credits.fields.never_expires_point": "Điểm không có thời hạn",
        "store_credits.fields.order_prefix": "Sử dụng điểm cho đơn hàng",
        "store_credits.fields.product_review_reward": "Đã hoàn tất đánh giá cho đơn hàng <a href=\"{{link}}\">{{ orderNumber }}</a>",
        "store_credits.fields.remarks": "Lý do thay đổi điểm",
        "store_credits.fields.revert_credit": "Điểm được trả lại từ đơn hàng bị hủy",
        "store_credits.fields.revert_credit.order_edit": "Điểm tín dụng được hoàn trả từ đơn hàng đã chỉnh sửa",
        "store_credits.fields.revert_credit.order_split": "Credits reverted from split order",
        "store_credits.fields.revert_credit.return": "Điểm tín dụng được hoàn lại từ đơn hàng hoàn lại",
        "store_credits.fields.revert_credit.return_order_revert": "Reverted credits; from return",
        "store_credits.fields.user_credit_expired": "Điểm đã hết hạn",
        "store_credits.fields.value": "Biến động điểm",
        "store_credits.fields.welcome_credit": "Điểm Chào mừng",
        "store_credits.fields.welcome_member_referral_credit": "Sign up with referral link",
        "store_credits.no_data": "Không có hồ sơ điểm",
        "store_credits.title": "Điểm tại cửa hàng",
        "store_stock.available": "Available for online purchase, pickup at store",
        "store_stock.current_availability": "Tồn kho của cửa hàng hiện tại",
        "store_stock.description": "We sell products based on on-site availability and only reserve inventory for customers who have completed their booking. We recommend placing your order and confirming your pickup date before coming to the store.",
        "store_stock.loading": "Kiểm tra hàng tồn kho",
        "store_stock.sold_out": "Hết hàng",
        "store_stock.take_a_while": "Sẽ mất một lúc...",
        "subscribe.facebook.dialog.cancel": "Cancel",
        "subscribe.facebook.dialog.info": "Due to updates in Facebook’s messaging guidelines, please complete the subscription process on Messenger. Click \"Subscribe now\" and you will be directed to Messenger.<br />Log in to Messenger and <span class=\"facebook-subscription-dialog-hint\">click the \"Get Started\" button</span> in the chat. You will be redirected to Messenger to complete the subscription. (If you've previously messaged the store's Facebook Page, opening the conversation on Messenger will be considered a successful subscription.)",
        "subscribe.facebook.dialog.subscribe": "Subscribe now",
        "subscribe.facebook.dialog.title": "Subscribe to Facebook",
        "subscribe.facebook.failure": "Failed to subscribe. Please log in to Facebook again.",
        "subscribe.failure": "Failed to subscribe. Please contact the store.",
        "subscribe.failure.already_bound": "Failed to subscribe. This social account is already bound to another member. Please contact the store to unbind.",
        "subscribe.line.failure": "Failed to subscribe. Please log in to LINE again.",
        "subscribe.line.failure.already_used": "Failed to subscribe. This LINE account is already used for registration by another member. Please log in with the LINE account and try again.",
        "subscribe.line.failure.different_id": "Failed to subscribe. Please log in with the LINE account of the member account.",
        "subscribe.success": "Subscribed successfully.",
        "tax.applied_store_credit": "Sử dụng điểm tín dụng",
        "tax.calculate_tax": "Tính thuế",
        "tax.calculate_tax.info.1": "Vui lòng cập nhật thuế và nhấp vào",
        "tax.calculate_tax.info.2": "trước khi thanh toán",
        "tax.calculation_content": "(Tổng sản phẩm đã tính thuế - Số tiền chiết khấu) * Thuế + Phí giao hàng * Thuế",
        "tax.calculation_title": "Cách tính thuế:",
        "tax.delivery_tax": "運費稅",
        "tax.delivery_tax_rate": "Delivery Tax Rate",
        "tax.discounts": "Giảm giá & Khuyến mãi",
        "tax.fee": "Thuế",
        "tax.price_updated": "Giá đã cập nhật",
        "tax.product_price": "Giá sản phẩm",
        "tax.sales_tax": "Thuế bán hàng",
        "tax.sales_tax_rate": "Thuế suất bán hàng",
        "tax.service_tax": "Thuế dịch vụ",
        "tax.service_tax_rate": "Mức phí dịch vụ",
        "tax.total": "Tổng cộng",
        "tcat.time_slot.01": "Trước 13:00",
        "tcat.time_slot.02": "14:00 - 18:00",
        "tcat.time_slot.04": "Bất kỳ khoảng thời gian nào",
        "tcat.time_slot.title": "Khoảng thời gian đến",
        "trial_order_dialog.checkout": "Start Checkout",
        "trial_order_dialog.content": "You may : become a member, subscribe newsletter, purchase add-on items and experience other powerful features. Order limitation will be removed once the shop get upgraded.",
        "trial_order_dialog.reach_limit.check_plan": "Return to homepage",
        "trial_order_dialog.reach_limit.content": "You can continue shopping and checkout when the store is officially in operation!<br/>If you have any questions about the operation of the store, please contact the store.",
        "trial_order_dialog.reach_limit.continue": "Contact the store",
        "trial_order_dialog.reach_limit.title": "Order limit has been reached for trial operation.",
        "trial_order_dialog.title": "Welcome to checkout. The store is on free trial with up to creating 10 orders.",
        "unsubscribe.failure": "Failed to unsubscribe, please try again later.",
        "unsubscribe.success": "Unsubscribed successfully.",
        "user.add_credit_card": "Add a credit card",
        "user.add_credit_card.cancel": "Cancel",
        "user.add_credit_card.fail": "Failed to add the credit card, please try again later",
        "user.add_credit_card.remind": "Note: {{ label }} will be deducted as verification fee. It will be refunded to your card afterwards.",
        "user.add_credit_card.submit": "Submit",
        "user.add_credit_card.success": "The card has been added successfully.",
        "user.credit_card.expired": "Expired",
        "user.credit_card.system.error": "System error. Please try again later",
        "user.credit_card_list.delete": "Delete",
        "user.credit_card_list.processing": "Processing",
        "user.delete_credit_card": "Are you sure you want to delete the credit card from your account?",
        "user.delete_credit_card.cancel": "Cancel",
        "user.delete_credit_card.delete": "Delete",
        "user.delete_credit_card.description": "Once the credit card has been deleted, you need to re-enter card number for checkout next time.",
        "user.delete_credit_card.description.with_subscription_product": "Once the credit card has been deleted, you need to re-enter card number for checkout next time. If you had paid by this credit card for subscription orders, it will failed to complete the payment for the next order. You may go to Member > Orders to repay.",
        "user.delete_credit_card.fail": "Failed to delete the credit card, please try again later",
        "user.delete_credit_card.success": "The card has been deleted successfully.",
        "user.delivery_data.recipient_phone": "Số điện thoại của người nhận",
        "user.quick_signup.error.confirmed": "Số điện thoại di động này đã được sử dụng. ",
        "user.quick_signup.error.confirmed.url": "Đăng nhập ngay.",
        "user.quick_signup.error.format": "Lỗi Định dạng",
        "user.quick_signup.policy": "Tôi đồng ý với",
        "user.quick_signup.policy.url_content": " Điều khoản Sử dụng và Chính sách Quyền riêng tư của cửa hàng",
        "user.quick_signup.policy_with_age": "By proceeding, I agree to the<a href=\"{{ link }}\"> shop's Terms of Use and Privacy Policy</a> and I am over {{ age }}",
        "user.quick_signup.promotion": "Tôi muốn nhận thông tin cập nhật và chương trình khuyến mãi mới nhất",
        "user.quick_signup.submit": "Tham gia ngay",
        "user.quick_signup.title": "Gia nhập làm thành viên ngay!",
        "user.quick_signup.title.content": "Đừng bỏ lỡ những ưu đãi đặc biệt!",
        "user.quick_signup.validate.finish_hint": "Hoàn tất đăng ký để kiểm tra và sử dụng điểm của cửa hàng ngay!",
        "user.quick_signup.validate.hint.password": "Ít nhất 8 ký tự",
        "user.quick_signup.validate.hint.resend": "Bạn chưa nhận được mã kiểm tra? Vui lòng bấm vào đây để gửi lại.",
        "user.quick_signup.validate.hint.send": "Đã gửi mã số xác thực. Bạn có thể gửi lại mã mới sau {{count}}giây.",
        "user.quick_signup.validate.modify": " và cập nhật",
        "user.quick_signup.validate.phone": "Xác thực",
        "user.quick_signup.validate.placeholder.name": "Tên",
        "user.quick_signup.validate.placeholder.password": "Nhập mật khẩu",
        "user.quick_signup.validate.placeholder.sms": "Nhập mã số xác thực",
        "user.quick_signup.validate.previous": "quay lại",
        "user.quick_signup.validate.send.sms": "Gửi mã số xác thực",
        "user.quick_signup.validate.submit": "Hoàn tất Đăng ký",
        "user.quick_signup.validate.success": "Cảm ơn bạn đã gia nhập  làm thành viên！ <br/> Bạn có thể hoàn tất quy trình đăng ký, <br/>hoặc ",
        "user.quick_signup.validate.success.shop": "bắt đầu mua sắm ngay",
        "user.quick_signup.validate.title": "Tiếp tục Đăng ký",
        "user.quick_signup.validate.wrong.number": "Nếu số di động không đúng, xin hãy",
        "user.sign_up.check_phone.error": "This is same as current mobile phone.<br>Please change another phone if you want to update it.",
        "user.sign_up.email_verification.dialog.confirm": "Xác nhận",
        "user.sign_up.email_verification.dialog.description": "Xin hãy xác thực email ngay và địa chỉ email mới sẽ được cập nhật. Nếu bạn chưa nhận được thư, xin hãy nhập lại email và lưu lại.",
        "user.sign_up.email_verification.dialog.title": "Email Xác thực đã được gửi tới {{mail}}",
        "user_credit": "store credits",
        "user_reminder.coupon.action": "Claim now",
        "user_reminder.coupon.guest": "Please login to claim coupons.",
        "user_reminder.coupon.member": "There are unclaimed coupons. Please proceed and claim them!",
        "user_reminder.coupon.v2.desktop": "Your exclusive coupons",
        "user_reminder.coupon.v2.mobile": "Exclusive coupons for you. Claim now!",
        "user_reminder.member_referral.action": "Đăng ký ngay",
        "user_reminder.member_referral.member_point": "Đăng ký để kiếm {{ value }} điểm thành viên",
        "user_reminder.member_referral.user_credit": "Đăng ký để kiếm {{ value }} điểm tín dụng",
        "users.add.delivery_address": "Thêm địa chỉ mới",
        "users.add.delivery_address.maximum": "Bạn chỉ có thể thêm tối đa 5 địa chỉ.",
        "users.add.phone": "Add contact phone",
        "users.add.phone.maximum": "Bạn chỉ có thể thêm tối đa 5 số điện thoại.",
        "users.birthday.faq": "You should over certain age to register and shop at the online store.",
        "users.edit_member_info": "Chỉnh sửa thông tin thành viên",
        "users.einvoice_carrier": "Hóa đơn điện tử tổng hợp vào tài khoản của bạn",
        "users.error.maxlength": " quá dài.",
        "users.error.no_changes": "Không có thay đổi nào cần lưu.",
        "users.error.not_save_mobile_phone": "Vui lòng xác minh số điện thoại trước khi lưu thay đổi.",
        "users.error.phone.format": "Số điện thoại không hợp lệ",
        "users.error.phone.required": "Bắt buộc phải có số điện thoại’",
        "users.fields.callingCode": "Mã vùng",
        "users.fields.callingCodeHint": "Vui lòng chọn mã quốc gia cho số điện thoại",
        "users.fields.email": "Email",
        "users.fields.email.placeholder": "Email",
        "users.fields.mobile": "Mobile number",
        "users.fields.mobile.placeholder": "Mobile number",
        "users.fields.mobile_phone_or_email": "Email hoặc số di động",
        "users.fields.name": "Họ tên",
        "users.fields.name.placeholder": "Họ tên",
        "users.fields.password": "Mật khẩu",
        "users.fields.password.placeholder": "Mật khẩu",
        "users.member.normal-level": "Basic",
        "users.membership.all.spending_single_purchase": "Single purchase over {{spending}}.",
        "users.membership.all.spending_within_months": "Tổng giá trị mua hàng trên {{spending}} đồng trong thời hạn {{months}} tháng là thành viên.",
        "users.membership.all_tiers": "Xem tất cả các cấp độ thành viên",
        "users.membership.all_tiers.condition": "Membership",
        "users.membership.all_tiers.description": "Membership will downgrade on expiry date if extension condition is not meet.",
        "users.membership.expire.month_valid": "（Valid Period {{months}} Month(s))",
        "users.membership.expire.unlimited": "Never Expire",
        "users.membership.expiry_date": "Ngày hết hạn thành viên",
        "users.membership.extend_valid_period": "{{ type === \"within_interval\" ? \"Total\" : \"Single\" }} purchase over {{spending}} within membership valid period {{months}} months.",
        "users.membership.extension.condition": "Điều kiện mở rộng",
        "users.membership.extension.status": "Membership Extend Status",
        "users.membership.forget_password.email_sent": "We have sent an email to {{email}}. Open the email and reset your password.",
        "users.membership.max_level_tier": "Congrats! You are in TOP membership level.",
        "users.membership.member_info.birthday": "Sinh nhật",
        "users.membership.member_info.coupons": "{{count}} phiếu giảm giá",
        "users.membership.member_info.email": "Email",
        "users.membership.member_info.gender": "Giới tính",
        "users.membership.member_info.hint": "Điền thông tin thành viên sau: {{fields}}, bạn có thể nhận được {{rewards}} sau khi điền thông tin hồ sơ",
        "users.membership.member_info.member_points": "{{count}} điểm thành viên",
        "users.membership.member_info.mobile": "Số điện thoại",
        "users.membership.member_info.name": "Tên",
        "users.membership.member_info.sent": "Sau khi kiểm tra thông tin hoàn tất, phần thưởng Hoàn thành Hồ sơ Thành viên sẽ được phát hành!",
        "users.membership.member_info.symbol": ", ",
        "users.membership.member_info.title": "Phần thưởng hoàn thành hồ sơ thành viên",
        "users.membership.member_info.user_credits": "${{count}} tín dụng cửa hàng",
        "users.membership.offer.discount": "Ưu đãi dành cho thành viên",
        "users.membership.spending_single_purchase": "Nâng cấp bằng cách mua hàng đơn lẻ trên {{spending}} đồng",
        "users.membership.spending_within_months": "Upgrade with total purchase over {{spending}} within {{months}} month(s).",
        "users.membership.tier.expire.date": "Valid Period :",
        "users.membership.tier.expire.date.auto_downgrade.description": "Điều kiện nâng cấp sẽ được kiểm tra vào lúc nửa đêm. Việc nâng cấp thành viên sẽ không có hiệu lực nếu đơn hàng bị hủy/ hoàn tiền.",
        "users.membership.tier.expire.date.description": "Điều kiện nâng cấp sẽ được kiểm tra vào lúc nửa đêm. Việc nâng cấp thành viên sẽ không có hiệu lực nếu đơn hàng bị hủy/ hoàn tiền.",
        "users.membership.tier.expire.month": "{{month}} Month(s)",
        "users.membership.tier.extend": "Eligible to extend <b>{{tier}}</b>?",
        "users.membership.tier.extend.condition": " Extension Condition :",
        "users.membership.tier.extend.single_purchase": "No single purchase over {{dollar}} within {{month}}-month membership valid period.",
        "users.membership.tier.extend.single_purchase.can_extend": "You have a single purchase over {{dollar}} within {{month}}-month membership valid period. Membership extension will be effective on expiry date.",
        "users.membership.tier.extend.top_level.single_purchase": "No single purchase over {{dollar}} within {{month}}-month membership valid period.",
        "users.membership.tier.extend.top_level.single_purchase.can_extend": "You have a single purchase over {{dollar}} within membership valid period. Congrats! Membership extension will be effective on expiry date.",
        "users.membership.tier.extend.top_level.within_interval": "{{dollar}} more to extend",
        "users.membership.tier.extend.top_level.within_interval.can_extend": "Congrats! Extension will be effective on expiry date.",
        "users.membership.tier.extend.within_interval": "Your total purchase within {{month}}-month membership valid period is {{spending}}. {{dollar}} more to extend.",
        "users.membership.tier.extend.within_interval.can_extend": "Your total purchase within {{month}}-month membership valid period is over {{dollar}}. Extension will be effective on expiry date.",
        "users.membership.tier.extension.date.description": "Membership extension will not be effective if order has been cancelled/refunded.",
        "users.membership.tier.shopping_discount": "Member offer {{discount}}% off",
        "users.membership.tier.upgrade.completed": "Đủ điều kiện để nâng cấp",
        "users.membership.tier.upgrade.condition": "Upgrade Condition of this level :",
        "users.membership.tier.upgrade.condition.continue": "Tiếp tục mua hàng?",
        "users.membership.tier.upgrade.condition.dollar": "Hiện tại mua đơn lẻ vẫn chưa đạt trên {{dollar}}.",
        "users.membership.tier.upgrade.gap_dollar": "{{dollar}} more to upgrade",
        "users.membership.tier.upgrade.to_next_level.single": "Nâng cấp lên?",
        "users.membership.tier.upgrade.to_next_level.within": "Total purchase within {{month}} month(s) ",
        "users.membership.upgrade.next_tier": "Nâng cấp thành {{tier_name}}",
        "users.membership.upgrade.next_tier.discount": " để nhận {{discount}}% ưu đãi.",
        "users.phone.migrate.notification": "To update shop functions, only one of customer’s phone number will be kept from 2019/1/15 onwards. If you have saved more than one phone number, please confirm the latest one is correct.",
        "users.save.email_verification.send": "Email xác minh đã được gửi",
        "users.save.email_verification.success": "Các thay đổi của bạn đã được lưu. Địa chỉ email sẽ được cập nhật sau khi hoàn tất xác thực.",
        "users.save.success": "Các thay đổi của bạn đã được lưu.",
        "users.signin.error.invalid.email": "Invalid email or password.",
        "users.signin.error.invalid.mobile": "Invalid mobile number or password.",
        "users.signup.email": "Đăng ký qua Email",
        "users.signup.female": "Nữ",
        "users.signup.male": "Nam",
        "users.signup.mobile_phone": "Đăng ký qua số điện thoại di động",
        "users.signup.other": "Không khai báo",
        "users.signup.unconfirmed": "Chào mừng bạn trở lại! Để bảo vệ tài khoản của bạn, cần xác thực để đăng nhập vào tài khoản của bạn. Email xác thực đã được gửi tới {{email}}. Vui lòng kiểm tra trong hòm thư, xin cảm ơn!",
        "users.signup.verification.hint.send": "Đã gửi email xác thực. Bạn có thể gửi lại mã mới sau {{count}}giây.",
        "verification.email.trial_merchant.reach_limit.failure": "Cửa hàng đang trong giai đoạn dùng thử nên không gửi được email xác minh. Nếu có nhu cầu vui lòng liên hệ với cửa hàng.",
        "view_my_coupons": "View my coupons",
        "whatsapp_messenger_checkbox.subscribe": "Send via WhatsApp",
        "wishlist.messages.remove_error": "Không thể xóa sản phẩm trong danh sách mong muốn.",
        "wishlist.signin_register": "Đăng nhập / đăng ký ngay bây giờ",
        "zeek.pickup.area": "Self pickup district",
        "zeek.pickup.region": "Self pickup region",
        "zeek.station.address": "Self pickup address",
        "zeek.station.name": "Self pickup location name",
        "zeek.station.provider": "Self pickup service provider"
      });
    $translateProvider.preferredLanguage("vi");
  },
]);
